/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dist_index_mjs__ = __webpack_require__(11);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_index_mjs__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_index_mjs__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_index_mjs__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_index_mjs__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_index_mjs__["e"]; });


if (false) {
  console.warn('You are running production build of Inferno in development mode. Use dev:module entry point.');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(5);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(3);
module.exports = __webpack_require__(10);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where Inferno gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes Inferno's erratic future behavior.
  __webpack_require__(4).enable();
  window.Promise = __webpack_require__(7);
}

// fetch() polyfill for making API calls.
__webpack_require__(8);

// Object.assign() is commonly used with Inferno.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(9);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(1);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(1);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inferno__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(12);
Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["e" /* render */])(Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["b" /* createComponentVNode */])(2,__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]),document.getElementById('app'));

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Component; });
/* unused harmony export EMPTY_OBJ */
/* unused harmony export NO_OP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createComponentVNode; });
/* unused harmony export createPortal */
/* unused harmony export createRenderer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createTextVNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createVNode; });
/* unused harmony export directClone */
/* unused harmony export getFlagsForElementVnode */
/* unused harmony export getNumberStyleValue */
/* unused harmony export hydrate */
/* unused harmony export linkEvent */
/* unused harmony export normalizeProps */
/* unused harmony export options */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return render; });
/* unused harmony export version */
var NO_OP = '$NO_OP';
var ERROR_MSG = 'a runtime error occured! Use Inferno in development environment to find the error.';
// This should be boolean and not reference to window.document
var isBrowser = !!(typeof window !== 'undefined' && window.document);
// this is MUCH faster than .constructor === Array and instanceof Array
// in Node 7 and the later versions of V8, slower in older versions though
var isArray = Array.isArray;
function isStringOrNumber(o) {
    var type = typeof o;
    return type === 'string' || type === 'number';
}
function isNullOrUndef(o) {
    return isUndefined(o) || isNull(o);
}
function isInvalid(o) {
    return isNull(o) || o === false || isTrue(o) || isUndefined(o);
}
function isFunction(o) {
    return typeof o === 'function';
}
function isString(o) {
    return typeof o === 'string';
}
function isNumber(o) {
    return typeof o === 'number';
}
function isNull(o) {
    return o === null;
}
function isTrue(o) {
    return o === true;
}
function isUndefined(o) {
    return o === void 0;
}
function isDefined(o) {
    return o !== void 0;
}
function isObject(o) {
    return typeof o === 'object';
}
function throwError(message) {
    if (!message) {
        message = ERROR_MSG;
    }
    throw new Error(("Inferno Error: " + message));
}
function combineFrom(first, second) {
    var out = {};
    if (first) {
        for (var key in first) {
            out[key] = first[key];
        }
    }
    if (second) {
        for (var key$1 in second) {
            out[key$1] = second[key$1];
        }
    }
    return out;
}

var keyPrefix = '$';
function getVNode(childFlags, children, className, flags, key, props, ref, type) {
    {
        return {
            childFlags: childFlags,
            children: children,
            className: className,
            dom: null,
            flags: flags,
            key: key === void 0 ? null : key,
            parentVNode: null,
            props: props === void 0 ? null : props,
            ref: ref === void 0 ? null : ref,
            type: type
        };
    }
    return {
        childFlags: childFlags,
        children: children,
        className: className,
        dom: null,
        flags: flags,
        isValidated: false,
        key: key === void 0 ? null : key,
        parentVNode: null,
        props: props === void 0 ? null : props,
        ref: ref === void 0 ? null : ref,
        type: type
    };
}
function createVNode(flags, type, className, children, childFlags, props, key, ref) {
    var childFlag = childFlags === void 0 ? 1 /* HasInvalidChildren */ : childFlags;
    var vNode = getVNode(childFlag, children, className, flags, key, props, ref, type);
    var optsVNode = options.createVNode;
    if (typeof optsVNode === 'function') {
        optsVNode(vNode);
    }
    if (childFlag === 0 /* UnknownChildren */) {
        normalizeChildren(vNode, vNode.children);
    }
    return vNode;
}
function createComponentVNode(flags, type, props, key, ref) {
    if ((flags & 2 /* ComponentUnknown */) > 0) {
        flags = isDefined(type.prototype) && isFunction(type.prototype.render) ? 4 /* ComponentClass */ : 8 /* ComponentFunction */;
    }
    // set default props
    var defaultProps = type.defaultProps;
    if (!isNullOrUndef(defaultProps)) {
        if (!props) {
            props = {}; // Props can be referenced and modified at application level so always create new object
        }
        for (var prop in defaultProps) {
            if (isUndefined(props[prop])) {
                props[prop] = defaultProps[prop];
            }
        }
    }
    if ((flags & 8 /* ComponentFunction */) > 0) {
        var defaultHooks = type.defaultHooks;
        if (!isNullOrUndef(defaultHooks)) {
            if (!ref) {
                // As ref cannot be referenced from application level, we can use the same refs object
                ref = defaultHooks;
            }
            else {
                for (var prop$1 in defaultHooks) {
                    if (isUndefined(ref[prop$1])) {
                        ref[prop$1] = defaultHooks[prop$1];
                    }
                }
            }
        }
    }
    var vNode = getVNode(1 /* HasInvalidChildren */, null, null, flags, key, props, ref, type);
    var optsVNode = options.createVNode;
    if (isFunction(optsVNode)) {
        optsVNode(vNode);
    }
    return vNode;
}
function createTextVNode(text, key) {
    return getVNode(1 /* HasInvalidChildren */, isNullOrUndef(text) ? '' : text, null, 16 /* Text */, key, null, null, null);
}
function normalizeProps(vNode) {
    var props = vNode.props;
    if (props) {
        if (vNode.flags & 481 /* Element */) {
            if (isDefined(props.children) && isNullOrUndef(vNode.children)) {
                normalizeChildren(vNode, props.children);
            }
            if (isDefined(props.className)) {
                vNode.className = props.className || null;
                props.className = undefined;
            }
        }
        if (isDefined(props.key)) {
            vNode.key = props.key;
            props.key = undefined;
        }
        if (isDefined(props.ref)) {
            vNode.ref = props.ref;
            props.ref = undefined;
        }
    }
    return vNode;
}
function directClone(vNodeToClone) {
    var newVNode;
    var flags = vNodeToClone.flags;
    if (flags & 14 /* Component */) {
        var props;
        var propsToClone = vNodeToClone.props;
        if (!isNull(propsToClone)) {
            props = {};
            for (var key in propsToClone) {
                props[key] = propsToClone[key];
            }
        }
        newVNode = createComponentVNode(flags, vNodeToClone.type, props, vNodeToClone.key, vNodeToClone.ref);
    }
    else if (flags & 481 /* Element */) {
        var children = vNodeToClone.children;
        newVNode = createVNode(flags, vNodeToClone.type, vNodeToClone.className, children, 0 /* UnknownChildren */, vNodeToClone.props, vNodeToClone.key, vNodeToClone.ref);
    }
    else if (flags & 16 /* Text */) {
        newVNode = createTextVNode(vNodeToClone.children, vNodeToClone.key);
    }
    else if (flags & 1024 /* Portal */) {
        newVNode = vNodeToClone;
    }
    return newVNode;
}
function createVoidVNode() {
    return createTextVNode('', null);
}
function _normalizeVNodes(nodes, result, index, currentKey) {
    for (var len = nodes.length; index < len; index++) {
        var n = nodes[index];
        if (!isInvalid(n)) {
            var newKey = currentKey + keyPrefix + index;
            if (isArray(n)) {
                _normalizeVNodes(n, result, 0, newKey);
            }
            else {
                if (isStringOrNumber(n)) {
                    n = createTextVNode(n, newKey);
                }
                else {
                    var oldKey = n.key;
                    var isPrefixedKey = isString(oldKey) && oldKey[0] === keyPrefix;
                    if (!isNull(n.dom) || isPrefixedKey) {
                        n = directClone(n);
                    }
                    if (isNull(oldKey) || isPrefixedKey) {
                        n.key = newKey;
                    }
                    else {
                        n.key = currentKey + oldKey;
                    }
                }
                result.push(n);
            }
        }
    }
}
function getFlagsForElementVnode(type) {
    if (type === 'svg') {
        return 32 /* SvgElement */;
    }
    if (type === 'input') {
        return 64 /* InputElement */;
    }
    if (type === 'select') {
        return 256 /* SelectElement */;
    }
    if (type === 'textarea') {
        return 128 /* TextareaElement */;
    }
    return 1 /* HtmlElement */;
}
function normalizeChildren(vNode, children) {
    var newChildren;
    var newChildFlags;
    // Don't change children to match strict equal (===) true in patching
    if (isInvalid(children)) {
        newChildFlags = 1 /* HasInvalidChildren */;
        newChildren = children;
    }
    else if (isString(children)) {
        newChildFlags = 2 /* HasVNodeChildren */;
        newChildren = createTextVNode(children);
    }
    else if (isNumber(children)) {
        newChildFlags = 2 /* HasVNodeChildren */;
        newChildren = createTextVNode(children + '');
    }
    else if (isArray(children)) {
        var len = children.length;
        if (len === 0) {
            newChildren = null;
            newChildFlags = 1 /* HasInvalidChildren */;
        }
        else {
            // we assign $ which basically means we've flagged this array for future note
            // if it comes back again, we need to clone it, as people are using it
            // in an immutable way
            // tslint:disable-next-line
            if (Object.isFrozen(children) || children['$'] === true) {
                children = children.slice();
            }
            newChildFlags = 8 /* HasKeyedChildren */;
            for (var i = 0; i < len; i++) {
                var n = children[i];
                if (isInvalid(n) || isArray(n)) {
                    newChildren = newChildren || children.slice(0, i);
                    _normalizeVNodes(children, newChildren, i, '');
                    break;
                }
                else if (isStringOrNumber(n)) {
                    newChildren = newChildren || children.slice(0, i);
                    newChildren.push(createTextVNode(n, keyPrefix + i));
                }
                else {
                    var key = n.key;
                    var isNullDom = isNull(n.dom);
                    var isNullKey = isNull(key);
                    var isPrefixed = !isNullKey && key[0] === keyPrefix;
                    if (!isNullDom || isNullKey || isPrefixed) {
                        newChildren = newChildren || children.slice(0, i);
                        if (!isNullDom || isPrefixed) {
                            n = directClone(n);
                        }
                        if (isNullKey || isPrefixed) {
                            n.key = keyPrefix + i;
                        }
                        newChildren.push(n);
                    }
                    else if (newChildren) {
                        newChildren.push(n);
                    }
                }
            }
            newChildren = newChildren || children;
            newChildren.$ = true;
        }
    }
    else {
        newChildren = children;
        if (!isNull(children.dom)) {
            newChildren = directClone(children);
        }
        newChildFlags = 2 /* HasVNodeChildren */;
    }
    vNode.children = newChildren;
    vNode.childFlags = newChildFlags;
    return vNode;
}
var options = {
    afterMount: null,
    afterRender: null,
    afterUpdate: null,
    beforeRender: null,
    beforeUnmount: null,
    createVNode: null,
    roots: []
};

/**
 * Links given data to event as first parameter
 * @param {*} data data to be linked, it will be available in function as first parameter
 * @param {Function} event Function to be called when event occurs
 * @returns {{data: *, event: Function}}
 */
function linkEvent(data, event) {
    if (isFunction(event)) {
        return { data: data, event: event };
    }
    return null; // Return null when event is invalid, to avoid creating unnecessary event handlers
}

var xlinkNS = 'http://www.w3.org/1999/xlink';
var xmlNS = 'http://www.w3.org/XML/1998/namespace';
var svgNS = 'http://www.w3.org/2000/svg';
var namespaces = {
    'xlink:actuate': xlinkNS,
    'xlink:arcrole': xlinkNS,
    'xlink:href': xlinkNS,
    'xlink:role': xlinkNS,
    'xlink:show': xlinkNS,
    'xlink:title': xlinkNS,
    'xlink:type': xlinkNS,
    'xml:base': xmlNS,
    'xml:lang': xmlNS,
    'xml:space': xmlNS
};

// We need EMPTY_OBJ defined in one place.
// Its used for comparison so we cant inline it into shared
var EMPTY_OBJ = {};
var LIFECYCLE = [];
function appendChild(parentDom, dom) {
    parentDom.appendChild(dom);
}
function insertOrAppend(parentDom, newNode, nextNode) {
    if (isNullOrUndef(nextNode)) {
        appendChild(parentDom, newNode);
    }
    else {
        parentDom.insertBefore(newNode, nextNode);
    }
}
function documentCreateElement(tag, isSVG) {
    if (isSVG === true) {
        return document.createElementNS(svgNS, tag);
    }
    return document.createElement(tag);
}
function replaceChild(parentDom, newDom, lastDom) {
    parentDom.replaceChild(newDom, lastDom);
}
function removeChild(parentDom, dom) {
    parentDom.removeChild(dom);
}
function callAll(arrayFn) {
    var listener;
    while ((listener = arrayFn.shift()) !== undefined) {
        listener();
    }
}

var attachedEventCounts = {};
var attachedEvents = {};
function handleEvent(name, nextEvent, dom) {
    var eventsLeft = attachedEventCounts[name];
    var eventsObject = dom.$EV;
    if (nextEvent) {
        if (!eventsLeft) {
            attachedEvents[name] = attachEventToDocument(name);
            attachedEventCounts[name] = 0;
        }
        if (!eventsObject) {
            eventsObject = dom.$EV = {};
        }
        if (!eventsObject[name]) {
            attachedEventCounts[name]++;
        }
        eventsObject[name] = nextEvent;
    }
    else if (eventsObject && eventsObject[name]) {
        attachedEventCounts[name]--;
        if (eventsLeft === 1) {
            document.removeEventListener(normalizeEventName(name), attachedEvents[name]);
            attachedEvents[name] = null;
        }
        eventsObject[name] = nextEvent;
    }
}
function dispatchEvents(event, target, isClick, name, eventData) {
    var dom = target;
    while (!isNull(dom)) {
        // Html Nodes can be nested fe: span inside button in that scenario browser does not handle disabled attribute on parent,
        // because the event listener is on document.body
        // Don't process clicks on disabled elements
        if (isClick && dom.disabled) {
            return;
        }
        var eventsObject = dom.$EV;
        if (eventsObject) {
            var currentEvent = eventsObject[name];
            if (currentEvent) {
                // linkEvent object
                eventData.dom = dom;
                if (currentEvent.event) {
                    currentEvent.event(currentEvent.data, event);
                }
                else {
                    currentEvent(event);
                }
                if (event.cancelBubble) {
                    return;
                }
            }
        }
        dom = dom.parentNode;
    }
}
function normalizeEventName(name) {
    return name.substr(2).toLowerCase();
}
function stopPropagation() {
    this.cancelBubble = true;
    this.stopImmediatePropagation();
}
function attachEventToDocument(name) {
    var docEvent = function (event) {
        var type = event.type;
        var isClick = type === 'click' || type === 'dblclick';
        if (isClick && event.button !== 0) {
            // Firefox incorrectly triggers click event for mid/right mouse buttons.
            // This bug has been active for 12 years.
            // https://bugzilla.mozilla.org/show_bug.cgi?id=184051
            event.preventDefault();
            event.stopPropagation();
            return false;
        }
        event.stopPropagation = stopPropagation;
        // Event data needs to be object to save reference to currentTarget getter
        var eventData = {
            dom: document
        };
        try {
            Object.defineProperty(event, 'currentTarget', {
                configurable: true,
                get: function get() {
                    return eventData.dom;
                }
            });
        }
        catch (e) {
            /* safari7 and phantomJS will crash */
        }
        dispatchEvents(event, event.target, isClick, name, eventData);
    };
    document.addEventListener(normalizeEventName(name), docEvent);
    return docEvent;
}

function isSameInnerHTML(dom, innerHTML) {
    var tempdom = document.createElement('i');
    tempdom.innerHTML = innerHTML;
    return tempdom.innerHTML === dom.innerHTML;
}
function isSamePropsInnerHTML(dom, props) {
    return Boolean(props && props.dangerouslySetInnerHTML && props.dangerouslySetInnerHTML.__html && isSameInnerHTML(dom, props.dangerouslySetInnerHTML.__html));
}

function triggerEventListener(props, methodName, e) {
    if (props[methodName]) {
        var listener = props[methodName];
        if (listener.event) {
            listener.event(listener.data, e);
        }
        else {
            listener(e);
        }
    }
    else {
        var nativeListenerName = methodName.toLowerCase();
        if (props[nativeListenerName]) {
            props[nativeListenerName](e);
        }
    }
}
function createWrappedFunction(methodName, applyValue) {
    var fnMethod = function (e) {
        e.stopPropagation();
        var vNode = this.$V;
        // If vNode is gone by the time event fires, no-op
        if (!vNode) {
            return;
        }
        var props = vNode.props || EMPTY_OBJ;
        var dom = vNode.dom;
        if (isString(methodName)) {
            triggerEventListener(props, methodName, e);
        }
        else {
            for (var i = 0; i < methodName.length; i++) {
                triggerEventListener(props, methodName[i], e);
            }
        }
        if (isFunction(applyValue)) {
            var newVNode = this.$V;
            var newProps = newVNode.props || EMPTY_OBJ;
            applyValue(newProps, dom, false, newVNode);
        }
    };
    Object.defineProperty(fnMethod, 'wrapped', {
        configurable: false,
        enumerable: false,
        value: true,
        writable: false
    });
    return fnMethod;
}

function isCheckedType(type) {
    return type === 'checkbox' || type === 'radio';
}
var onTextInputChange = createWrappedFunction('onInput', applyValueInput);
var wrappedOnChange = createWrappedFunction(['onClick', 'onChange'], applyValueInput);
/* tslint:disable-next-line:no-empty */
function emptywrapper(event) {
    event.stopPropagation();
}
emptywrapper.wrapped = true;
function inputEvents(dom, nextPropsOrEmpty) {
    if (isCheckedType(nextPropsOrEmpty.type)) {
        dom.onchange = wrappedOnChange;
        dom.onclick = emptywrapper;
    }
    else {
        dom.oninput = onTextInputChange;
    }
}
function applyValueInput(nextPropsOrEmpty, dom) {
    var type = nextPropsOrEmpty.type;
    var value = nextPropsOrEmpty.value;
    var checked = nextPropsOrEmpty.checked;
    var multiple = nextPropsOrEmpty.multiple;
    var defaultValue = nextPropsOrEmpty.defaultValue;
    var hasValue = !isNullOrUndef(value);
    if (type && type !== dom.type) {
        dom.setAttribute('type', type);
    }
    if (!isNullOrUndef(multiple) && multiple !== dom.multiple) {
        dom.multiple = multiple;
    }
    if (!isNullOrUndef(defaultValue) && !hasValue) {
        dom.defaultValue = defaultValue + '';
    }
    if (isCheckedType(type)) {
        if (hasValue) {
            dom.value = value;
        }
        if (!isNullOrUndef(checked)) {
            dom.checked = checked;
        }
    }
    else {
        if (hasValue && dom.value !== value) {
            dom.defaultValue = value;
            dom.value = value;
        }
        else if (!isNullOrUndef(checked)) {
            dom.checked = checked;
        }
    }
}

function updateChildOptionGroup(vNode, value) {
    var type = vNode.type;
    if (type === 'optgroup') {
        var children = vNode.children;
        var childFlags = vNode.childFlags;
        if (childFlags & 12 /* MultipleChildren */) {
            for (var i = 0, len = children.length; i < len; i++) {
                updateChildOption(children[i], value);
            }
        }
        else if (childFlags === 2 /* HasVNodeChildren */) {
            updateChildOption(children, value);
        }
    }
    else {
        updateChildOption(vNode, value);
    }
}
function updateChildOption(vNode, value) {
    var props = vNode.props || EMPTY_OBJ;
    var dom = vNode.dom;
    // we do this as multiple may have changed
    dom.value = props.value;
    if ((isArray(value) && value.indexOf(props.value) !== -1) || props.value === value) {
        dom.selected = true;
    }
    else if (!isNullOrUndef(value) || !isNullOrUndef(props.selected)) {
        dom.selected = props.selected || false;
    }
}
var onSelectChange = createWrappedFunction('onChange', applyValueSelect);
function selectEvents(dom) {
    dom.onchange = onSelectChange;
}
function applyValueSelect(nextPropsOrEmpty, dom, mounting, vNode) {
    var multiplePropInBoolean = Boolean(nextPropsOrEmpty.multiple);
    if (!isNullOrUndef(nextPropsOrEmpty.multiple) && multiplePropInBoolean !== dom.multiple) {
        dom.multiple = multiplePropInBoolean;
    }
    var childFlags = vNode.childFlags;
    if ((childFlags & 1 /* HasInvalidChildren */) === 0) {
        var children = vNode.children;
        var value = nextPropsOrEmpty.value;
        if (mounting && isNullOrUndef(value)) {
            value = nextPropsOrEmpty.defaultValue;
        }
        if (childFlags & 12 /* MultipleChildren */) {
            for (var i = 0, len = children.length; i < len; i++) {
                updateChildOptionGroup(children[i], value);
            }
        }
        else if (childFlags === 2 /* HasVNodeChildren */) {
            updateChildOptionGroup(children, value);
        }
    }
}

var onTextareaInputChange = createWrappedFunction('onInput', applyValueTextArea);
var wrappedOnChange$1 = createWrappedFunction('onChange');
function textAreaEvents(dom, nextPropsOrEmpty) {
    dom.oninput = onTextareaInputChange;
    if (nextPropsOrEmpty.onChange) {
        dom.onchange = wrappedOnChange$1;
    }
}
function applyValueTextArea(nextPropsOrEmpty, dom, mounting) {
    var value = nextPropsOrEmpty.value;
    var domValue = dom.value;
    if (isNullOrUndef(value)) {
        if (mounting) {
            var defaultValue = nextPropsOrEmpty.defaultValue;
            if (!isNullOrUndef(defaultValue) && defaultValue !== domValue) {
                dom.defaultValue = defaultValue;
                dom.value = defaultValue;
            }
        }
    }
    else if (domValue !== value) {
        /* There is value so keep it controlled */
        dom.defaultValue = value;
        dom.value = value;
    }
}

/**
 * There is currently no support for switching same input between controlled and nonControlled
 * If that ever becomes a real issue, then re design controlled elements
 * Currently user must choose either controlled or non-controlled and stick with that
 */
function processElement(flags, vNode, dom, nextPropsOrEmpty, mounting, isControlled) {
    if (flags & 64 /* InputElement */) {
        applyValueInput(nextPropsOrEmpty, dom);
    }
    else if (flags & 256 /* SelectElement */) {
        applyValueSelect(nextPropsOrEmpty, dom, mounting, vNode);
    }
    else if (flags & 128 /* TextareaElement */) {
        applyValueTextArea(nextPropsOrEmpty, dom, mounting);
    }
    if (isControlled) {
        dom.$V = vNode;
    }
}
function addFormElementEventHandlers(flags, dom, nextPropsOrEmpty) {
    if (flags & 64 /* InputElement */) {
        inputEvents(dom, nextPropsOrEmpty);
    }
    else if (flags & 256 /* SelectElement */) {
        selectEvents(dom);
    }
    else if (flags & 128 /* TextareaElement */) {
        textAreaEvents(dom, nextPropsOrEmpty);
    }
}
function isControlledFormElement(nextPropsOrEmpty) {
    return nextPropsOrEmpty.type && isCheckedType(nextPropsOrEmpty.type) ? !isNullOrUndef(nextPropsOrEmpty.checked) : !isNullOrUndef(nextPropsOrEmpty.value);
}

function remove(vNode, parentDom) {
    unmount(vNode);
    if (!isNull(parentDom)) {
        removeChild(parentDom, vNode.dom);
        // Let carbage collector free memory
        vNode.dom = null;
    }
}
function unmount(vNode) {
    var flags = vNode.flags;
    if (flags & 481 /* Element */) {
        var ref = vNode.ref;
        var props = vNode.props;
        if (isFunction(ref)) {
            ref(null);
        }
        var children = vNode.children;
        var childFlags = vNode.childFlags;
        if (childFlags & 12 /* MultipleChildren */) {
            unmountAllChildren(children);
        }
        else if (childFlags === 2 /* HasVNodeChildren */) {
            unmount(children);
        }
        if (!isNull(props)) {
            for (var name in props) {
                switch (name) {
                    case 'onClick':
                    case 'onDblClick':
                    case 'onFocusIn':
                    case 'onFocusOut':
                    case 'onKeyDown':
                    case 'onKeyPress':
                    case 'onKeyUp':
                    case 'onMouseDown':
                    case 'onMouseMove':
                    case 'onMouseUp':
                    case 'onSubmit':
                    case 'onTouchEnd':
                    case 'onTouchMove':
                    case 'onTouchStart':
                        handleEvent(name, null, vNode.dom);
                        break;
                    default:
                        break;
                }
            }
        }
    }
    else if (flags & 14 /* Component */) {
        var instance = vNode.children;
        var ref$1 = vNode.ref;
        if (flags & 4 /* ComponentClass */) {
            if (isFunction(options.beforeUnmount)) {
                options.beforeUnmount(vNode);
            }
            if (isFunction(instance.componentWillUnmount)) {
                instance.componentWillUnmount();
            }
            if (isFunction(ref$1)) {
                ref$1(null);
            }
            instance.$UN = true;
            unmount(instance.$LI);
        }
        else {
            if (!isNullOrUndef(ref$1) && isFunction(ref$1.onComponentWillUnmount)) {
                ref$1.onComponentWillUnmount(vNode.dom, vNode.props || EMPTY_OBJ);
            }
            unmount(instance);
        }
    }
    else if (flags & 1024 /* Portal */) {
        var children$1 = vNode.children;
        if (!isNull(children$1) && isObject(children$1)) {
            remove(children$1, vNode.type);
        }
    }
}
function unmountAllChildren(children) {
    for (var i = 0, len = children.length; i < len; i++) {
        unmount(children[i]);
    }
}
function removeAllChildren(dom, children) {
    unmountAllChildren(children);
    dom.textContent = '';
}

function createLinkEvent(linkEvent, nextValue) {
    return function (e) {
        linkEvent(nextValue.data, e);
    };
}
function patchEvent(name, lastValue, nextValue, dom) {
    var nameLowerCase = name.toLowerCase();
    if (!isFunction(nextValue) && !isNullOrUndef(nextValue)) {
        var linkEvent = nextValue.event;
        if (linkEvent && isFunction(linkEvent)) {
            dom[nameLowerCase] = createLinkEvent(linkEvent, nextValue);
        }
        else {
            // Development warning
            
        }
    }
    else {
        var domEvent = dom[nameLowerCase];
        // if the function is wrapped, that means it's been controlled by a wrapper
        if (!domEvent || !domEvent.wrapped) {
            dom[nameLowerCase] = nextValue;
        }
    }
}
function getNumberStyleValue(style, value) {
    switch (style) {
        case 'animationIterationCount':
        case 'borderImageOutset':
        case 'borderImageSlice':
        case 'borderImageWidth':
        case 'boxFlex':
        case 'boxFlexGroup':
        case 'boxOrdinalGroup':
        case 'columnCount':
        case 'fillOpacity':
        case 'flex':
        case 'flexGrow':
        case 'flexNegative':
        case 'flexOrder':
        case 'flexPositive':
        case 'flexShrink':
        case 'floodOpacity':
        case 'fontWeight':
        case 'gridColumn':
        case 'gridRow':
        case 'lineClamp':
        case 'lineHeight':
        case 'opacity':
        case 'order':
        case 'orphans':
        case 'stopOpacity':
        case 'strokeDasharray':
        case 'strokeDashoffset':
        case 'strokeMiterlimit':
        case 'strokeOpacity':
        case 'strokeWidth':
        case 'tabSize':
        case 'widows':
        case 'zIndex':
        case 'zoom':
            return value;
        default:
            return value + 'px';
    }
}
// We are assuming here that we come from patchProp routine
// -nextAttrValue cannot be null or undefined
function patchStyle(lastAttrValue, nextAttrValue, dom) {
    var domStyle = dom.style;
    var style;
    var value;
    if (isString(nextAttrValue)) {
        domStyle.cssText = nextAttrValue;
        return;
    }
    if (!isNullOrUndef(lastAttrValue) && !isString(lastAttrValue)) {
        for (style in nextAttrValue) {
            // do not add a hasOwnProperty check here, it affects performance
            value = nextAttrValue[style];
            if (value !== lastAttrValue[style]) {
                domStyle[style] = isNumber(value) ? getNumberStyleValue(style, value) : value;
            }
        }
        for (style in lastAttrValue) {
            if (isNullOrUndef(nextAttrValue[style])) {
                domStyle[style] = '';
            }
        }
    }
    else {
        for (style in nextAttrValue) {
            value = nextAttrValue[style];
            domStyle[style] = isNumber(value) ? getNumberStyleValue(style, value) : value;
        }
    }
}
function patchProp(prop, lastValue, nextValue, dom, isSVG, hasControlledValue, lastVNode) {
    switch (prop) {
        case 'onClick':
        case 'onDblClick':
        case 'onFocusIn':
        case 'onFocusOut':
        case 'onKeyDown':
        case 'onKeyPress':
        case 'onKeyUp':
        case 'onMouseDown':
        case 'onMouseMove':
        case 'onMouseUp':
        case 'onSubmit':
        case 'onTouchEnd':
        case 'onTouchMove':
        case 'onTouchStart':
            handleEvent(prop, nextValue, dom);
            break;
        case 'children':
        case 'childrenType':
        case 'className':
        case 'defaultValue':
        case 'key':
        case 'multiple':
        case 'ref':
            return;
        case 'allowfullscreen':
        case 'autoFocus':
        case 'autoplay':
        case 'capture':
        case 'checked':
        case 'controls':
        case 'default':
        case 'disabled':
        case 'hidden':
        case 'indeterminate':
        case 'loop':
        case 'muted':
        case 'novalidate':
        case 'open':
        case 'readOnly':
        case 'required':
        case 'reversed':
        case 'scoped':
        case 'seamless':
        case 'selected':
            prop = prop === 'autoFocus' ? prop.toLowerCase() : prop;
            dom[prop] = !!nextValue;
            break;
        case 'defaultChecked':
        case 'value':
        case 'volume':
            if (hasControlledValue && prop === 'value') {
                return;
            }
            var value = isNullOrUndef(nextValue) ? '' : nextValue;
            if (dom[prop] !== value) {
                dom[prop] = value;
            }
            break;
        case 'dangerouslySetInnerHTML':
            var lastHtml = (lastValue && lastValue.__html) || '';
            var nextHtml = (nextValue && nextValue.__html) || '';
            if (lastHtml !== nextHtml) {
                if (!isNullOrUndef(nextHtml) && !isSameInnerHTML(dom, nextHtml)) {
                    if (!isNull(lastVNode)) {
                        if (lastVNode.childFlags & 12 /* MultipleChildren */) {
                            unmountAllChildren(lastVNode.children);
                        }
                        else if (lastVNode.childFlags === 2 /* HasVNodeChildren */) {
                            unmount(lastVNode.children);
                        }
                        lastVNode.children = null;
                        lastVNode.childFlags = 1 /* HasInvalidChildren */;
                    }
                    dom.innerHTML = nextHtml;
                }
            }
            break;
        default:
            if (prop[0] === 'o' && prop[1] === 'n') {
                patchEvent(prop, lastValue, nextValue, dom);
            }
            else if (isNullOrUndef(nextValue)) {
                dom.removeAttribute(prop);
            }
            else if (prop === 'style') {
                patchStyle(lastValue, nextValue, dom);
            }
            else if (isSVG && namespaces[prop]) {
                // We optimize for NS being boolean. Its 99.9% time false
                // If we end up in this path we can read property again
                dom.setAttributeNS(namespaces[prop], prop, nextValue);
            }
            else {
                dom.setAttribute(prop, nextValue);
            }
            break;
    }
}
function mountProps(vNode, flags, props, dom, isSVG) {
    var hasControlledValue = false;
    var isFormElement = (flags & 448 /* FormElement */) > 0;
    if (isFormElement) {
        hasControlledValue = isControlledFormElement(props);
        if (hasControlledValue) {
            addFormElementEventHandlers(flags, dom, props);
        }
    }
    for (var prop in props) {
        // do not add a hasOwnProperty check here, it affects performance
        patchProp(prop, null, props[prop], dom, isSVG, hasControlledValue, null);
    }
    if (isFormElement) {
        processElement(flags, vNode, dom, props, true, hasControlledValue);
    }
}

function createClassComponentInstance(vNode, Component, props, context) {
    var instance = new Component(props, context);
    vNode.children = instance;
    instance.$V = vNode;
    instance.$BS = false;
    instance.context = context;
    if (instance.props === EMPTY_OBJ) {
        instance.props = props;
    }
    instance.$UN = false;
    if (isFunction(instance.componentWillMount)) {
        instance.$BR = true;
        instance.componentWillMount();
        if (instance.$PSS) {
            var state = instance.state;
            var pending = instance.$PS;
            if (isNull(state)) {
                instance.state = pending;
            }
            else {
                for (var key in pending) {
                    state[key] = pending[key];
                }
            }
            instance.$PSS = false;
            instance.$PS = null;
        }
        instance.$BR = false;
    }
    if (isFunction(options.beforeRender)) {
        options.beforeRender(instance);
    }
    var input = handleComponentInput(instance.render(props, instance.state, context), vNode);
    var childContext;
    if (isFunction(instance.getChildContext)) {
        childContext = instance.getChildContext();
    }
    if (isNullOrUndef(childContext)) {
        instance.$CX = context;
    }
    else {
        instance.$CX = combineFrom(context, childContext);
    }
    if (isFunction(options.afterRender)) {
        options.afterRender(instance);
    }
    instance.$LI = input;
    return instance;
}
function handleComponentInput(input, componentVNode) {
    // Development validation
    if (isInvalid(input)) {
        input = createVoidVNode();
    }
    else if (isStringOrNumber(input)) {
        input = createTextVNode(input, null);
    }
    else {
        if (input.dom) {
            input = directClone(input);
        }
        if (input.flags & 14 /* Component */) {
            // if we have an input that is also a component, we run into a tricky situation
            // where the root vNode needs to always have the correct DOM entry
            // we can optimise this in the future, but this gets us out of a lot of issues
            input.parentVNode = componentVNode;
        }
    }
    return input;
}

function mount(vNode, parentDom, lifecycle, context, isSVG) {
    var flags = vNode.flags;
    if (flags & 481 /* Element */) {
        return mountElement(vNode, parentDom, lifecycle, context, isSVG);
    }
    if (flags & 14 /* Component */) {
        return mountComponent(vNode, parentDom, lifecycle, context, isSVG, (flags & 4 /* ComponentClass */) > 0);
    }
    if (flags & 512 /* Void */ || flags & 16 /* Text */) {
        return mountText(vNode, parentDom);
    }
    if (flags & 1024 /* Portal */) {
        mount(vNode.children, vNode.type, lifecycle, context, false);
        return (vNode.dom = mountText(createVoidVNode(), parentDom));
    }
    // Development validation, in production we don't need to throw because it crashes anyway
    
}
function mountText(vNode, parentDom) {
    var dom = (vNode.dom = document.createTextNode(vNode.children));
    if (!isNull(parentDom)) {
        appendChild(parentDom, dom);
    }
    return dom;
}
function mountElement(vNode, parentDom, lifecycle, context, isSVG) {
    var flags = vNode.flags;
    var children = vNode.children;
    var props = vNode.props;
    var className = vNode.className;
    var ref = vNode.ref;
    var childFlags = vNode.childFlags;
    isSVG = isSVG || (flags & 32 /* SvgElement */) > 0;
    var dom = documentCreateElement(vNode.type, isSVG);
    vNode.dom = dom;
    if (!isNullOrUndef(className) && className !== '') {
        if (isSVG) {
            dom.setAttribute('class', className);
        }
        else {
            dom.className = className;
        }
    }
    if (!isNull(parentDom)) {
        appendChild(parentDom, dom);
    }
    if ((childFlags & 1 /* HasInvalidChildren */) === 0) {
        var childrenIsSVG = isSVG === true && vNode.type !== 'foreignObject';
        if (childFlags === 2 /* HasVNodeChildren */) {
            mount(children, dom, lifecycle, context, childrenIsSVG);
        }
        else if (childFlags & 12 /* MultipleChildren */) {
            mountArrayChildren(children, dom, lifecycle, context, childrenIsSVG);
        }
    }
    if (!isNull(props)) {
        mountProps(vNode, flags, props, dom, isSVG);
    }
    if (isFunction(ref)) {
        mountRef(dom, ref, lifecycle);
    }
    return dom;
}
function mountArrayChildren(children, dom, lifecycle, context, isSVG) {
    for (var i = 0, len = children.length; i < len; i++) {
        var child = children[i];
        if (!isNull(child.dom)) {
            children[i] = child = directClone(child);
        }
        mount(child, dom, lifecycle, context, isSVG);
    }
}
function mountComponent(vNode, parentDom, lifecycle, context, isSVG, isClass) {
    var dom;
    var type = vNode.type;
    var props = vNode.props || EMPTY_OBJ;
    var ref = vNode.ref;
    if (isClass) {
        var instance = createClassComponentInstance(vNode, type, props, context);
        var input = instance.$LI;
        vNode.dom = dom = mount(input, null, lifecycle, instance.$CX, isSVG);
        mountClassComponentCallbacks(vNode, ref, instance, lifecycle);
        instance.$UPD = false;
    }
    else {
        var input$1 = handleComponentInput(type(props, context), vNode);
        vNode.dom = dom = mount(input$1, null, lifecycle, context, isSVG);
        vNode.children = input$1;
        mountFunctionalComponentCallbacks(props, ref, dom, lifecycle);
    }
    if (!isNull(parentDom)) {
        appendChild(parentDom, dom);
    }
    return dom;
}
function createClassMountCallback(instance, hasAfterMount, afterMount, vNode, hasDidMount) {
    return function () {
        instance.$UPD = true;
        if (hasAfterMount) {
            afterMount(vNode);
        }
        if (hasDidMount) {
            instance.componentDidMount();
        }
        instance.$UPD = false;
    };
}
function mountClassComponentCallbacks(vNode, ref, instance, lifecycle) {
    if (isFunction(ref)) {
        ref(instance);
    }
    else {
        
    }
    var hasDidMount = isFunction(instance.componentDidMount);
    var afterMount = options.afterMount;
    var hasAfterMount = isFunction(afterMount);
    if (hasDidMount || hasAfterMount) {
        lifecycle.push(createClassMountCallback(instance, hasAfterMount, afterMount, vNode, hasDidMount));
    }
}
// Create did mount callback lazily to avoid creating function context if not needed
function createOnMountCallback(ref, dom, props) {
    return function () { return ref.onComponentDidMount(dom, props); };
}
function mountFunctionalComponentCallbacks(props, ref, dom, lifecycle) {
    if (!isNullOrUndef(ref)) {
        if (isFunction(ref.onComponentWillMount)) {
            ref.onComponentWillMount(props);
        }
        if (isFunction(ref.onComponentDidMount)) {
            lifecycle.push(createOnMountCallback(ref, dom, props));
        }
    }
}
function mountRef(dom, value, lifecycle) {
    lifecycle.push(function () { return value(dom); });
}

function hydrateComponent(vNode, dom, lifecycle, context, isSVG, isClass) {
    var type = vNode.type;
    var ref = vNode.ref;
    var props = vNode.props || EMPTY_OBJ;
    if (isClass) {
        var instance = createClassComponentInstance(vNode, type, props, context);
        var input = instance.$LI;
        hydrateVNode(input, dom, lifecycle, instance.$CX, isSVG);
        vNode.dom = input.dom;
        mountClassComponentCallbacks(vNode, ref, instance, lifecycle);
        instance.$UPD = false; // Mount finished allow going sync
    }
    else {
        var input$1 = handleComponentInput(type(props, context), vNode);
        hydrateVNode(input$1, dom, lifecycle, context, isSVG);
        vNode.children = input$1;
        vNode.dom = input$1.dom;
        mountFunctionalComponentCallbacks(props, ref, dom, lifecycle);
    }
}
function hydrateElement(vNode, dom, lifecycle, context, isSVG) {
    var children = vNode.children;
    var props = vNode.props;
    var className = vNode.className;
    var flags = vNode.flags;
    var ref = vNode.ref;
    isSVG = isSVG || (flags & 32 /* SvgElement */) > 0;
    if (dom.nodeType !== 1 || dom.tagName.toLowerCase() !== vNode.type) {
        var newDom = mountElement(vNode, null, lifecycle, context, isSVG);
        vNode.dom = newDom;
        replaceChild(dom.parentNode, newDom, dom);
    }
    else {
        vNode.dom = dom;
        var childNode = dom.firstChild;
        var childFlags = vNode.childFlags;
        if ((childFlags & 1 /* HasInvalidChildren */) === 0) {
            var nextSibling = null;
            while (childNode) {
                nextSibling = childNode.nextSibling;
                if (childNode.nodeType === 8) {
                    if (childNode.data === '!') {
                        dom.replaceChild(document.createTextNode(''), childNode);
                    }
                    else {
                        dom.removeChild(childNode);
                    }
                }
                childNode = nextSibling;
            }
            childNode = dom.firstChild;
            if (childFlags === 2 /* HasVNodeChildren */) {
                if (isNull(childNode)) {
                    mount(children, dom, lifecycle, context, isSVG);
                }
                else {
                    nextSibling = childNode.nextSibling;
                    hydrateVNode(children, childNode, lifecycle, context, isSVG);
                    childNode = nextSibling;
                }
            }
            else if (childFlags & 12 /* MultipleChildren */) {
                for (var i = 0, len = children.length; i < len; i++) {
                    var child = children[i];
                    if (isNull(childNode)) {
                        mount(child, dom, lifecycle, context, isSVG);
                    }
                    else {
                        nextSibling = childNode.nextSibling;
                        hydrateVNode(child, childNode, lifecycle, context, isSVG);
                        childNode = nextSibling;
                    }
                }
            }
            // clear any other DOM nodes, there should be only a single entry for the root
            while (childNode) {
                nextSibling = childNode.nextSibling;
                dom.removeChild(childNode);
                childNode = nextSibling;
            }
        }
        else if (!isNull(dom.firstChild) && !isSamePropsInnerHTML(dom, props)) {
            dom.textContent = ''; // dom has content, but VNode has no children remove everything from DOM
            if (flags & 448 /* FormElement */) {
                // If element is form element, we need to clear defaultValue also
                dom.defaultValue = '';
            }
        }
        if (!isNull(props)) {
            mountProps(vNode, flags, props, dom, isSVG);
        }
        if (isNullOrUndef(className)) {
            if (dom.className !== '') {
                dom.removeAttribute('class');
            }
        }
        else if (isSVG) {
            dom.setAttribute('class', className);
        }
        else {
            dom.className = className;
        }
        if (isFunction(ref)) {
            mountRef(dom, ref, lifecycle);
        }
        else {
            
        }
    }
}
function hydrateText(vNode, dom) {
    if (dom.nodeType !== 3) {
        var newDom = mountText(vNode, null);
        vNode.dom = newDom;
        replaceChild(dom.parentNode, newDom, dom);
    }
    else {
        var text = vNode.children;
        if (dom.nodeValue !== text) {
            dom.nodeValue = text;
        }
        vNode.dom = dom;
    }
}
function hydrateVNode(vNode, dom, lifecycle, context, isSVG) {
    var flags = vNode.flags;
    if (flags & 14 /* Component */) {
        hydrateComponent(vNode, dom, lifecycle, context, isSVG, (flags & 4 /* ComponentClass */) > 0);
    }
    else if (flags & 481 /* Element */) {
        hydrateElement(vNode, dom, lifecycle, context, isSVG);
    }
    else if (flags & 16 /* Text */) {
        hydrateText(vNode, dom);
    }
    else if (flags & 512 /* Void */) {
        vNode.dom = dom;
    }
    else {
        throwError();
    }
}
function hydrate(input, parentDom, callback) {
    var dom = parentDom.firstChild;
    if (!isNull(dom)) {
        if (!isInvalid(input)) {
            hydrateVNode(input, dom, LIFECYCLE, EMPTY_OBJ, false);
        }
        dom = parentDom.firstChild;
        // clear any other DOM nodes, there should be only a single entry for the root
        while ((dom = dom.nextSibling)) {
            parentDom.removeChild(dom);
        }
    }
    if (LIFECYCLE.length > 0) {
        callAll(LIFECYCLE);
    }
    if (!parentDom.$V) {
        options.roots.push(parentDom);
    }
    parentDom.$V = input;
    if (isFunction(callback)) {
        callback();
    }
}

function replaceWithNewNode(lastNode, nextNode, parentDom, lifecycle, context, isSVG) {
    unmount(lastNode);
    replaceChild(parentDom, mount(nextNode, null, lifecycle, context, isSVG), lastNode.dom);
}
function patch(lastVNode, nextVNode, parentDom, lifecycle, context, isSVG) {
    if (lastVNode !== nextVNode) {
        var nextFlags = nextVNode.flags;
        if (lastVNode.flags !== nextFlags || nextFlags & 2048 /* ReCreate */) {
            replaceWithNewNode(lastVNode, nextVNode, parentDom, lifecycle, context, isSVG);
        }
        else if (nextFlags & 481 /* Element */) {
            patchElement(lastVNode, nextVNode, parentDom, lifecycle, context, isSVG);
        }
        else if (nextFlags & 14 /* Component */) {
            patchComponent(lastVNode, nextVNode, parentDom, lifecycle, context, isSVG, (nextFlags & 4 /* ComponentClass */) > 0);
        }
        else if (nextFlags & 16 /* Text */) {
            patchText(lastVNode, nextVNode, parentDom);
        }
        else if (nextFlags & 512 /* Void */) {
            nextVNode.dom = lastVNode.dom;
        }
        else {
            // Portal
            patchPortal(lastVNode, nextVNode, lifecycle, context);
        }
    }
}
function patchPortal(lastVNode, nextVNode, lifecycle, context) {
    var lastContainer = lastVNode.type;
    var nextContainer = nextVNode.type;
    var nextChildren = nextVNode.children;
    patchChildren(lastVNode.childFlags, nextVNode.childFlags, lastVNode.children, nextChildren, lastContainer, lifecycle, context, false);
    nextVNode.dom = lastVNode.dom;
    if (lastContainer !== nextContainer && !isInvalid(nextChildren)) {
        var node = nextChildren.dom;
        lastContainer.removeChild(node);
        nextContainer.appendChild(node);
    }
}
function patchElement(lastVNode, nextVNode, parentDom, lifecycle, context, isSVG) {
    var nextTag = nextVNode.type;
    if (lastVNode.type !== nextTag) {
        replaceWithNewNode(lastVNode, nextVNode, parentDom, lifecycle, context, isSVG);
    }
    else {
        var dom = lastVNode.dom;
        var nextFlags = nextVNode.flags;
        var lastProps = lastVNode.props;
        var nextProps = nextVNode.props;
        var isFormElement = false;
        var hasControlledValue = false;
        var nextPropsOrEmpty;
        nextVNode.dom = dom;
        isSVG = isSVG || (nextFlags & 32 /* SvgElement */) > 0;
        // inlined patchProps  -- starts --
        if (lastProps !== nextProps) {
            var lastPropsOrEmpty = lastProps || EMPTY_OBJ;
            nextPropsOrEmpty = nextProps || EMPTY_OBJ;
            if (nextPropsOrEmpty !== EMPTY_OBJ) {
                isFormElement = (nextFlags & 448 /* FormElement */) > 0;
                if (isFormElement) {
                    hasControlledValue = isControlledFormElement(nextPropsOrEmpty);
                }
                for (var prop in nextPropsOrEmpty) {
                    var lastValue = lastPropsOrEmpty[prop];
                    var nextValue = nextPropsOrEmpty[prop];
                    if (lastValue !== nextValue) {
                        patchProp(prop, lastValue, nextValue, dom, isSVG, hasControlledValue, lastVNode);
                    }
                }
            }
            if (lastPropsOrEmpty !== EMPTY_OBJ) {
                for (var prop$1 in lastPropsOrEmpty) {
                    // do not add a hasOwnProperty check here, it affects performance
                    if (!nextPropsOrEmpty.hasOwnProperty(prop$1) && !isNullOrUndef(lastPropsOrEmpty[prop$1])) {
                        patchProp(prop$1, lastPropsOrEmpty[prop$1], null, dom, isSVG, hasControlledValue, lastVNode);
                    }
                }
            }
        }
        var lastChildren = lastVNode.children;
        var nextChildren = nextVNode.children;
        var nextRef = nextVNode.ref;
        var lastClassName = lastVNode.className;
        var nextClassName = nextVNode.className;
        if (lastChildren !== nextChildren) {
            patchChildren(lastVNode.childFlags, nextVNode.childFlags, lastChildren, nextChildren, dom, lifecycle, context, isSVG && nextTag !== 'foreignObject');
        }
        if (isFormElement) {
            processElement(nextFlags, nextVNode, dom, nextPropsOrEmpty, false, hasControlledValue);
        }
        // inlined patchProps  -- ends --
        if (lastClassName !== nextClassName) {
            if (isNullOrUndef(nextClassName)) {
                dom.removeAttribute('class');
            }
            else if (isSVG) {
                dom.setAttribute('class', nextClassName);
            }
            else {
                dom.className = nextClassName;
            }
        }
        if (isFunction(nextRef) && lastVNode.ref !== nextRef) {
            mountRef(dom, nextRef, lifecycle);
        }
        else {
            
        }
    }
}
function patchChildren(lastChildFlags, nextChildFlags, lastChildren, nextChildren, parentDOM, lifecycle, context, isSVG) {
    switch (lastChildFlags) {
        case 2 /* HasVNodeChildren */:
            switch (nextChildFlags) {
                case 2 /* HasVNodeChildren */:
                    patch(lastChildren, nextChildren, parentDOM, lifecycle, context, isSVG);
                    break;
                case 1 /* HasInvalidChildren */:
                    remove(lastChildren, parentDOM);
                    break;
                default:
                    remove(lastChildren, parentDOM);
                    mountArrayChildren(nextChildren, parentDOM, lifecycle, context, isSVG);
                    break;
            }
            break;
        case 1 /* HasInvalidChildren */:
            switch (nextChildFlags) {
                case 2 /* HasVNodeChildren */:
                    mount(nextChildren, parentDOM, lifecycle, context, isSVG);
                    break;
                case 1 /* HasInvalidChildren */:
                    break;
                default:
                    mountArrayChildren(nextChildren, parentDOM, lifecycle, context, isSVG);
                    break;
            }
            break;
        default:
            if (nextChildFlags & 12 /* MultipleChildren */) {
                var lastLength = lastChildren.length;
                var nextLength = nextChildren.length;
                // Fast path's for both algorithms
                if (lastLength === 0) {
                    if (nextLength > 0) {
                        mountArrayChildren(nextChildren, parentDOM, lifecycle, context, isSVG);
                    }
                }
                else if (nextLength === 0) {
                    removeAllChildren(parentDOM, lastChildren);
                }
                else {
                    if (nextChildFlags === 8 /* HasKeyedChildren */ && lastChildFlags === 8 /* HasKeyedChildren */) {
                        patchKeyedChildren(lastChildren, nextChildren, parentDOM, lifecycle, context, isSVG, lastLength, nextLength);
                    }
                    else {
                        patchNonKeyedChildren(lastChildren, nextChildren, parentDOM, lifecycle, context, isSVG, lastLength, nextLength);
                    }
                }
            }
            else if (nextChildFlags === 1 /* HasInvalidChildren */) {
                removeAllChildren(parentDOM, lastChildren);
            }
            else {
                removeAllChildren(parentDOM, lastChildren);
                mount(nextChildren, parentDOM, lifecycle, context, isSVG);
            }
            break;
    }
}
function updateClassComponent(instance, nextState, nextVNode, nextProps, parentDom, lifecycle, context, isSVG, force, fromSetState) {
    var lastState = instance.state;
    var lastProps = instance.props;
    nextVNode.children = instance;
    var lastInput = instance.$LI;
    var renderOutput;
    if (instance.$UN) {
        return;
    }
    if (lastProps !== nextProps || nextProps === EMPTY_OBJ) {
        if (!fromSetState && isFunction(instance.componentWillReceiveProps)) {
            instance.$BR = true;
            instance.componentWillReceiveProps(nextProps, context);
            // If instance component was removed during its own update do nothing...
            if (instance.$UN) {
                return;
            }
            instance.$BR = false;
        }
        if (instance.$PSS) {
            nextState = combineFrom(nextState, instance.$PS);
            instance.$PSS = false;
            instance.$PS = null;
        }
    }
    /* Update if scu is not defined, or it returns truthy value or force */
    var hasSCU = isFunction(instance.shouldComponentUpdate);
    if (force || !hasSCU || (hasSCU && instance.shouldComponentUpdate(nextProps, nextState, context))) {
        if (isFunction(instance.componentWillUpdate)) {
            instance.$BS = true;
            instance.componentWillUpdate(nextProps, nextState, context);
            instance.$BS = false;
        }
        instance.props = nextProps;
        instance.state = nextState;
        instance.context = context;
        if (isFunction(options.beforeRender)) {
            options.beforeRender(instance);
        }
        renderOutput = instance.render(nextProps, nextState, context);
        if (isFunction(options.afterRender)) {
            options.afterRender(instance);
        }
        var didUpdate = renderOutput !== NO_OP;
        var childContext;
        if (isFunction(instance.getChildContext)) {
            childContext = instance.getChildContext();
        }
        if (isNullOrUndef(childContext)) {
            childContext = context;
        }
        else {
            childContext = combineFrom(context, childContext);
        }
        instance.$CX = childContext;
        if (didUpdate) {
            var nextInput = (instance.$LI = handleComponentInput(renderOutput, nextVNode));
            patch(lastInput, nextInput, parentDom, lifecycle, childContext, isSVG);
            if (isFunction(instance.componentDidUpdate)) {
                instance.componentDidUpdate(lastProps, lastState);
            }
            if (isFunction(options.afterUpdate)) {
                options.afterUpdate(nextVNode);
            }
        }
    }
    else {
        instance.props = nextProps;
        instance.state = nextState;
        instance.context = context;
    }
    nextVNode.dom = instance.$LI.dom;
}
function patchComponent(lastVNode, nextVNode, parentDom, lifecycle, context, isSVG, isClass) {
    var nextType = nextVNode.type;
    var lastKey = lastVNode.key;
    var nextKey = nextVNode.key;
    if (lastVNode.type !== nextType || lastKey !== nextKey) {
        replaceWithNewNode(lastVNode, nextVNode, parentDom, lifecycle, context, isSVG);
    }
    else {
        var nextProps = nextVNode.props || EMPTY_OBJ;
        if (isClass) {
            var instance = lastVNode.children;
            instance.$UPD = true;
            updateClassComponent(instance, instance.state, nextVNode, nextProps, parentDom, lifecycle, context, isSVG, false, false);
            instance.$V = nextVNode;
            instance.$UPD = false;
        }
        else {
            var shouldUpdate = true;
            var lastProps = lastVNode.props;
            var nextHooks = nextVNode.ref;
            var nextHooksDefined = !isNullOrUndef(nextHooks);
            var lastInput = lastVNode.children;
            nextVNode.dom = lastVNode.dom;
            nextVNode.children = lastInput;
            if (nextHooksDefined && isFunction(nextHooks.onComponentShouldUpdate)) {
                shouldUpdate = nextHooks.onComponentShouldUpdate(lastProps, nextProps);
            }
            if (shouldUpdate !== false) {
                if (nextHooksDefined && isFunction(nextHooks.onComponentWillUpdate)) {
                    nextHooks.onComponentWillUpdate(lastProps, nextProps);
                }
                var nextInput = nextType(nextProps, context);
                if (nextInput !== NO_OP) {
                    nextInput = handleComponentInput(nextInput, nextVNode);
                    patch(lastInput, nextInput, parentDom, lifecycle, context, isSVG);
                    nextVNode.children = nextInput;
                    nextVNode.dom = nextInput.dom;
                    if (nextHooksDefined && isFunction(nextHooks.onComponentDidUpdate)) {
                        nextHooks.onComponentDidUpdate(lastProps, nextProps);
                    }
                }
            }
            else if (lastInput.flags & 14 /* Component */) {
                lastInput.parentVNode = nextVNode;
            }
        }
    }
}
function patchText(lastVNode, nextVNode, parentDom) {
    var nextText = nextVNode.children;
    var textNode = parentDom.firstChild;
    var dom;
    // Guard against external change on DOM node.
    if (isNull(textNode)) {
        parentDom.textContent = nextText;
        dom = parentDom.firstChild;
    }
    else {
        dom = lastVNode.dom;
        if (nextText !== lastVNode.children) {
            dom.nodeValue = nextText;
        }
    }
    nextVNode.dom = dom;
}
function patchNonKeyedChildren(lastChildren, nextChildren, dom, lifecycle, context, isSVG, lastChildrenLength, nextChildrenLength) {
    var commonLength = lastChildrenLength > nextChildrenLength ? nextChildrenLength : lastChildrenLength;
    var i = 0;
    for (; i < commonLength; i++) {
        var nextChild = nextChildren[i];
        if (nextChild.dom) {
            nextChild = nextChildren[i] = directClone(nextChild);
        }
        patch(lastChildren[i], nextChild, dom, lifecycle, context, isSVG);
    }
    if (lastChildrenLength < nextChildrenLength) {
        for (i = commonLength; i < nextChildrenLength; i++) {
            var nextChild$1 = nextChildren[i];
            if (nextChild$1.dom) {
                nextChild$1 = nextChildren[i] = directClone(nextChild$1);
            }
            appendChild(dom, mount(nextChild$1, null, lifecycle, context, isSVG));
        }
    }
    else if (lastChildrenLength > nextChildrenLength) {
        for (i = commonLength; i < lastChildrenLength; i++) {
            remove(lastChildren[i], dom);
        }
    }
}
function patchKeyedChildren(a, b, dom, lifecycle, context, isSVG, aLength, bLength) {
    var aEnd = aLength - 1;
    var bEnd = bLength - 1;
    var aStart = 0;
    var bStart = 0;
    var i;
    var j;
    var aNode;
    var bNode;
    var nextNode;
    var nextPos;
    var node;
    var aStartNode = a[aStart];
    var bStartNode = b[bStart];
    var aEndNode = a[aEnd];
    var bEndNode = b[bEnd];
    if (bStartNode.dom) {
        b[bStart] = bStartNode = directClone(bStartNode);
    }
    if (bEndNode.dom) {
        b[bEnd] = bEndNode = directClone(bEndNode);
    }
    // Step 1
    // tslint:disable-next-line
    outer: {
        // Sync nodes with the same key at the beginning.
        while (aStartNode.key === bStartNode.key) {
            patch(aStartNode, bStartNode, dom, lifecycle, context, isSVG);
            aStart++;
            bStart++;
            if (aStart > aEnd || bStart > bEnd) {
                break outer;
            }
            aStartNode = a[aStart];
            bStartNode = b[bStart];
            if (bStartNode.dom) {
                b[bStart] = bStartNode = directClone(bStartNode);
            }
        }
        // Sync nodes with the same key at the end.
        while (aEndNode.key === bEndNode.key) {
            patch(aEndNode, bEndNode, dom, lifecycle, context, isSVG);
            aEnd--;
            bEnd--;
            if (aStart > aEnd || bStart > bEnd) {
                break outer;
            }
            aEndNode = a[aEnd];
            bEndNode = b[bEnd];
            if (bEndNode.dom) {
                b[bEnd] = bEndNode = directClone(bEndNode);
            }
        }
    }
    if (aStart > aEnd) {
        if (bStart <= bEnd) {
            nextPos = bEnd + 1;
            nextNode = nextPos < bLength ? b[nextPos].dom : null;
            while (bStart <= bEnd) {
                node = b[bStart];
                if (node.dom) {
                    b[bStart] = node = directClone(node);
                }
                bStart++;
                insertOrAppend(dom, mount(node, null, lifecycle, context, isSVG), nextNode);
            }
        }
    }
    else if (bStart > bEnd) {
        while (aStart <= aEnd) {
            remove(a[aStart++], dom);
        }
    }
    else {
        var aLeft = aEnd - aStart + 1;
        var bLeft = bEnd - bStart + 1;
        var sources = new Array(bLeft);
        for (i = 0; i < bLeft; i++) {
            sources[i] = -1;
        }
        var moved = false;
        var pos = 0;
        var patched = 0;
        // When sizes are small, just loop them through
        if (bLeft <= 4 || aLeft * bLeft <= 16) {
            for (i = aStart; i <= aEnd; i++) {
                aNode = a[i];
                if (patched < bLeft) {
                    for (j = bStart; j <= bEnd; j++) {
                        bNode = b[j];
                        if (aNode.key === bNode.key) {
                            sources[j - bStart] = i;
                            if (pos > j) {
                                moved = true;
                            }
                            else {
                                pos = j;
                            }
                            if (bNode.dom) {
                                b[j] = bNode = directClone(bNode);
                            }
                            patch(aNode, bNode, dom, lifecycle, context, isSVG);
                            patched++;
                            a[i] = null;
                            break;
                        }
                    }
                }
            }
        }
        else {
            var keyIndex = {};
            // Map keys by their index in array
            for (i = bStart; i <= bEnd; i++) {
                keyIndex[b[i].key] = i;
            }
            // Try to patch same keys
            for (i = aStart; i <= aEnd; i++) {
                aNode = a[i];
                if (patched < bLeft) {
                    j = keyIndex[aNode.key];
                    if (isDefined(j)) {
                        bNode = b[j];
                        sources[j - bStart] = i;
                        if (pos > j) {
                            moved = true;
                        }
                        else {
                            pos = j;
                        }
                        if (bNode.dom) {
                            b[j] = bNode = directClone(bNode);
                        }
                        patch(aNode, bNode, dom, lifecycle, context, isSVG);
                        patched++;
                        a[i] = null;
                    }
                }
            }
        }
        // fast-path: if nothing patched remove all old and add all new
        if (aLeft === aLength && patched === 0) {
            removeAllChildren(dom, a);
            mountArrayChildren(b, dom, lifecycle, context, isSVG);
        }
        else {
            i = aLeft - patched;
            while (i > 0) {
                aNode = a[aStart++];
                if (!isNull(aNode)) {
                    remove(aNode, dom);
                    i--;
                }
            }
            if (moved) {
                var seq = lis_algorithm(sources);
                j = seq.length - 1;
                for (i = bLeft - 1; i >= 0; i--) {
                    if (sources[i] === -1) {
                        pos = i + bStart;
                        node = b[pos];
                        if (node.dom) {
                            b[pos] = node = directClone(node);
                        }
                        nextPos = pos + 1;
                        insertOrAppend(dom, mount(node, null, lifecycle, context, isSVG), nextPos < bLength ? b[nextPos].dom : null);
                    }
                    else if (j < 0 || i !== seq[j]) {
                        pos = i + bStart;
                        node = b[pos];
                        nextPos = pos + 1;
                        insertOrAppend(dom, node.dom, nextPos < bLength ? b[nextPos].dom : null);
                    }
                    else {
                        j--;
                    }
                }
            }
            else if (patched !== bLeft) {
                // when patched count doesn't match b length we need to insert those new ones
                // loop backwards so we can use insertBefore
                for (i = bLeft - 1; i >= 0; i--) {
                    if (sources[i] === -1) {
                        pos = i + bStart;
                        node = b[pos];
                        if (node.dom) {
                            b[pos] = node = directClone(node);
                        }
                        nextPos = pos + 1;
                        insertOrAppend(dom, mount(node, null, lifecycle, context, isSVG), nextPos < bLength ? b[nextPos].dom : null);
                    }
                }
            }
        }
    }
}
// // https://en.wikipedia.org/wiki/Longest_increasing_subsequence
function lis_algorithm(arr) {
    var p = arr.slice();
    var result = [0];
    var i;
    var j;
    var u;
    var v;
    var c;
    var len = arr.length;
    for (i = 0; i < len; i++) {
        var arrI = arr[i];
        if (arrI !== -1) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v = result.length - 1;
            while (u < v) {
                c = ((u + v) / 2) | 0;
                if (arr[result[c]] < arrI) {
                    u = c + 1;
                }
                else {
                    v = c;
                }
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) {
                    p[i] = result[u - 1];
                }
                result[u] = i;
            }
        }
    }
    u = result.length;
    v = result[u - 1];
    while (u-- > 0) {
        result[u] = v;
        v = p[v];
    }
    return result;
}

var roots = options.roots;
var documentBody = isBrowser ? document.body : null;
function render(input, parentDom, callback) {
    // Development warning
    if (input === NO_OP) {
        return;
    }
    var rootLen = roots.length;
    var rootInput;
    var index;
    for (index = 0; index < rootLen; index++) {
        if (roots[index] === parentDom) {
            rootInput = parentDom.$V;
            break;
        }
    }
    if (isUndefined(rootInput)) {
        if (!isInvalid(input)) {
            if (input.dom) {
                input = directClone(input);
            }
            if (isNull(parentDom.firstChild)) {
                mount(input, parentDom, LIFECYCLE, EMPTY_OBJ, false);
                parentDom.$V = input;
                roots.push(parentDom);
            }
            else {
                hydrate(input, parentDom);
            }
            rootInput = input;
        }
    }
    else {
        if (isNullOrUndef(input)) {
            remove(rootInput, parentDom);
            roots.splice(index, 1);
        }
        else {
            if (input.dom) {
                input = directClone(input);
            }
            patch(rootInput, input, parentDom, LIFECYCLE, EMPTY_OBJ, false);
            rootInput = parentDom.$V = input;
        }
    }
    if (LIFECYCLE.length > 0) {
        callAll(LIFECYCLE);
    }
    if (isFunction(callback)) {
        callback();
    }
    if (rootInput && rootInput.flags & 14 /* Component */) {
        return rootInput.children;
    }
}
function createRenderer(parentDom) {
    return function renderer(lastInput, nextInput) {
        if (!parentDom) {
            parentDom = lastInput;
        }
        render(nextInput, parentDom);
    };
}
function createPortal(children, container) {
    return createVNode(1024 /* Portal */, container, null, children, 0 /* UnknownChildren */, null, isInvalid(children) ? null : children.key, null);
}

var resolvedPromise = typeof Promise === 'undefined' ? null : Promise.resolve();
var fallbackMethod = typeof requestAnimationFrame === 'undefined' ? setTimeout : requestAnimationFrame;
function nextTick(fn) {
    if (resolvedPromise) {
        return resolvedPromise.then(fn);
    }
    return fallbackMethod(fn);
}
function queueStateChanges(component, newState, callback) {
    if (isFunction(newState)) {
        newState = newState(component.state, component.props, component.context);
    }
    var pending = component.$PS;
    if (isNullOrUndef(pending)) {
        component.$PS = newState;
    }
    else {
        for (var stateKey in newState) {
            pending[stateKey] = newState[stateKey];
        }
    }
    if (!component.$PSS && !component.$BR) {
        if (!component.$UPD) {
            component.$PSS = true;
            component.$UPD = true;
            applyState(component, false, callback);
            component.$UPD = false;
        }
        else {
            // Async
            var queue = component.$QU;
            if (isNull(queue)) {
                queue = component.$QU = [];
                nextTick(promiseCallback(component, queue));
            }
            if (isFunction(callback)) {
                queue.push(callback);
            }
        }
    }
    else {
        component.$PSS = true;
        if (component.$BR && isFunction(callback)) {
            LIFECYCLE.push(callback.bind(component));
        }
    }
}
function promiseCallback(component, queue) {
    return function () {
        component.$QU = null;
        component.$UPD = true;
        applyState(component, false, function () {
            for (var i = 0, len = queue.length; i < len; i++) {
                queue[i].call(component);
            }
        });
        component.$UPD = false;
    };
}
function applyState(component, force, callback) {
    if (component.$UN) {
        return;
    }
    if (force || !component.$BR) {
        component.$PSS = false;
        var pendingState = component.$PS;
        var prevState = component.state;
        var nextState = combineFrom(prevState, pendingState);
        var props = component.props;
        var context = component.context;
        component.$PS = null;
        var vNode = component.$V;
        var lastInput = component.$LI;
        var parentDom = lastInput.dom && lastInput.dom.parentNode;
        updateClassComponent(component, nextState, vNode, props, parentDom, LIFECYCLE, context, (vNode.flags & 32 /* SvgElement */) > 0, force, true);
        if (component.$UN) {
            return;
        }
        if ((component.$LI.flags & 1024 /* Portal */) === 0) {
            var dom = component.$LI.dom;
            while (!isNull((vNode = vNode.parentVNode))) {
                if ((vNode.flags & 14 /* Component */) > 0) {
                    vNode.dom = dom;
                }
            }
        }
        if (LIFECYCLE.length > 0) {
            callAll(LIFECYCLE);
        }
    }
    else {
        component.state = component.$PS;
        component.$PS = null;
    }
    if (isFunction(callback)) {
        callback.call(component);
    }
}
var Component = function Component(props, context) {
    this.state = null;
    // Internal properties
    this.$BR = false; // BLOCK RENDER
    this.$BS = true; // BLOCK STATE
    this.$PSS = false; // PENDING SET STATE
    this.$PS = null; // PENDING STATE (PARTIAL or FULL)
    this.$LI = null; // LAST INPUT
    this.$V = null; // VNODE
    this.$UN = false; // UNMOUNTED
    this.$CX = null; // CHILDCONTEXT
    this.$UPD = true; // UPDATING
    this.$QU = null; // QUEUE
    /** @type {object} */
    this.props = props || EMPTY_OBJ;
    /** @type {object} */
    this.context = context || EMPTY_OBJ; // context should not be mutable
};
Component.prototype.forceUpdate = function forceUpdate (callback) {
    if (this.$UN) {
        return;
    }
    applyState(this, true, callback);
};
Component.prototype.setState = function setState (newState, callback) {
    if (this.$UN) {
        return;
    }
    if (!this.$BS) {
        queueStateChanges(this, newState, callback);
    }
    else {
        // Development warning
        return;
    }
};
// tslint:disable-next-line:no-empty
Component.prototype.render = function render (nextProps, nextState, nextContext) { };
// Public
Component.defaultProps = null;

var version = "4.0.3";




/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inferno__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Nav__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Gallery__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Profile__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Footer__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AdminBar__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modals__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__stylus_main_css__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__stylus_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__stylus_main_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this));var development=window.location.toString().indexOf('localhost')>-1||window.location.toString().indexOf('localhost')>-1;var gallery=[];for(var i=0;i<20;i++){gallery.push({});}_this.publicURL=development?'http://'+window.location.hostname+':1250/':"https://jamesboothphotography.me.uk/";_this.state={loggedIn:false,modalActive:false,modals:{login:false,addPhoto:false,editPhoto:false,deletePhoto:false,lightbox:false},categories:[],gallery:gallery,activeFilter:"",filteredGallery:[]};return _this;}_createClass(App,[{key:'modalIsActive',value:function modalIsActive(){var _this2=this;var active=false;Object.keys(this.state.modals).forEach(function(key){if(_this2.state.modals[key]!==false)active=true;});return active;}},{key:'setActiveFilter',value:function setActiveFilter(activeFilter){if(activeFilter===this.state.activeFilter)activeFilter="";this.setState({activeFilter:activeFilter});this.updateFilteredGallery();}},{key:'updateFilteredGallery',value:function updateFilteredGallery(){var _this3=this;var filteredGallery=this.state.gallery.filter(function(image){return image.meta.category.indexOf(_this3.state.activeFilter)>-1||_this3.state.activeFilter==="";});if(filteredGallery===this.state.filteredGallery)return;this.setState({filteredGallery:filteredGallery});}},{key:'setModal',value:function setModal(modal){var active=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;// Rotate lightbox index around end of array
if(modal==="lightbox")if(active===this.state.filteredGallery.length)active=0;else if(active===-1)active=this.state.filteredGallery.length-1;var modals={};// Reset all modals to false
Object.keys(this.state.modals).forEach(function(key){return modals[key]=false;});// Enable/disable requested modal
modals[modal]=active;this.setState({modals:modals,modalActive:active});}},{key:'componentDidMount',value:function componentDidMount(){this.updateGallery();this.checkLogin();}},{key:'checkLogin',value:function checkLogin(){var _this4=this;fetch(this.publicURL+"checklogin/",{credentials:'include'}).then(function(res){return res.json();}).then(function(data){var loggedIn=data.name||false;if(loggedIn!==_this4.state.loggedIn)_this4.setState({loggedIn:loggedIn});});}},{key:'generateCategories',value:function generateCategories(gallery){var categories=[];gallery.forEach(function(image){image.meta.category.forEach(function(category){if(categories.indexOf(category)===-1)categories.push(category);});});return categories;}},{key:'updateGallery',value:function updateGallery(){var _this5=this;fetch(this.publicURL+"images/").then(function(res){return res.json();}).then(function(res){_this5.setState({gallery:res.gallery,galleryError:false,categories:_this5.generateCategories(res.gallery)});_this5.updateFilteredGallery();}).catch(function(err){console.log(err);_this5.setState({galleryError:"Error fetching images"});});}},{key:'swapImages',value:function swapImages(start,finish){var _this6=this;if(this.state.activeFilter!==""){var startId=this.state.filteredGallery[start]._id;var finishId=this.state.filteredGallery[finish]._id;this.state.gallery.forEach(function(image,i){if(image._id===startId)start=i;if(image._id===finishId)finish=i;});}fetch(this.publicURL+'admin/swap/'+start+'/'+finish,{credentials:'include',method:"POST"}).then(function(res){return res.json();}).then(function(res){console.log(res);_this6.setState({gallery:res.gallery,galleryError:false});_this6.updateFilteredGallery();}).catch(function(err){console.log(err);_this6.setState({galleryError:"Error swapping images"});});}},{key:'logOut',value:function logOut(){fetch(this.publicURL+"logout",{credentials:'include'}).then(function(res){window.scrollTo(0,0);window.location.reload();});}},{key:'render',value:function render(){var currentImage=void 0;if(this.state.modals.lightbox!==false)currentImage=this.state.filteredGallery[this.state.modals.lightbox];if(this.state.modals.editPhoto!==false)currentImage=this.state.filteredGallery[this.state.modals.editPhoto];if(this.modalIsActive())document.body.classList.add('Modal__active');else document.body.classList.remove('Modal__active');return Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','App '+(this.state.loggedIn?"admin":""),[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["b" /* createComponentVNode */])(2,__WEBPACK_IMPORTED_MODULE_6__Modals__["a" /* default */],{'url':this.publicURL,'modals':this.state.modals,'image':currentImage,'categories':this.state.categories,'updateGallery':this.updateGallery.bind(this),'setModal':this.setModal.bind(this)}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["b" /* createComponentVNode */])(2,__WEBPACK_IMPORTED_MODULE_5__AdminBar__["a" /* default */],{'setModal':this.setModal.bind(this),'username':this.state.loggedIn}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["b" /* createComponentVNode */])(2,__WEBPACK_IMPORTED_MODULE_1__Nav__["a" /* default */]),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["b" /* createComponentVNode */])(2,__WEBPACK_IMPORTED_MODULE_2__Gallery__["a" /* default */],{'url':this.publicURL,'loggedIn':this.state.loggedIn,'categories':this.state.categories,'activeFilter':this.state.activeFilter,'setModal':this.setModal.bind(this),'swapImages':this.swapImages.bind(this),'setActiveFilter':this.setActiveFilter.bind(this),'images':this.state.filteredGallery,'error':this.state.galleryError}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["b" /* createComponentVNode */])(2,__WEBPACK_IMPORTED_MODULE_3__Profile__["a" /* default */]),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["b" /* createComponentVNode */])(2,__WEBPACK_IMPORTED_MODULE_4__Footer__["a" /* default */],{'setModal':this.setModal.bind(this),'loggedIn':this.state.loggedIn,'logOut':this.logOut.bind(this)})],4);}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_inferno__["a" /* Component */]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inferno__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Nav=function(_Component){_inherits(Nav,_Component);function Nav(){_classCallCheck(this,Nav);return _possibleConstructorReturn(this,(Nav.__proto__||Object.getPrototypeOf(Nav)).apply(this,arguments));}_createClass(Nav,[{key:'scrollTo',value:function scrollTo(e,node){e.preventDefault();var target=e.target.getAttribute('href');var element=document.querySelector(target);element.scrollIntoView({behavior:'smooth',block:'start'});}},{key:'render',value:function render(){var _this2=this;return Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'header','Nav container',[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'img','Nav__logo',null,1,{'src':'/images/james-booth-photography-logo.svg','alt':'James Booth Photography Logo'}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'nav',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'ul','Nav__items',[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'li',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'a',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Gallery'),2,{'href':'#gallery','onClick':function onClick(e){return _this2.scrollTo(e);}}),2),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'li',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'a',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('About'),2,{'href':'#about','onClick':function onClick(e){return _this2.scrollTo(e);}}),2),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'li',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'a',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Gear'),2,{'href':'#gear','onClick':function onClick(e){return _this2.scrollTo(e);}}),2)],4),2)],4);}}]);return Nav;}(__WEBPACK_IMPORTED_MODULE_0_inferno__["a" /* Component */]);/* harmony default export */ __webpack_exports__["a"] = (Nav);

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inferno__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GalleryItem__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Gallery=function(_Component){_inherits(Gallery,_Component);function Gallery(){_classCallCheck(this,Gallery);return _possibleConstructorReturn(this,(Gallery.__proto__||Object.getPrototypeOf(Gallery)).apply(this,arguments));}_createClass(Gallery,[{key:'selectCategory',value:function selectCategory(e){e.preventDefault();var selectedValue=e.target.dataset.value;if(this.props.selectedCategory===selectedValue)this.props.setActiveFilter("");else this.props.setActiveFilter(e.target.dataset.value);}},{key:'render',value:function render(){var _this2=this;return Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'section','container',[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','Gallery__categories',this.props.categories.map(function(category){var selected=_this2.props.activeFilter===category;return Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'button','Gallery__categories--button '+(selected?"selected":""),category,0,{'data-value':category,'onClick':function onClick(e){return _this2.selectCategory(e);}});}),0),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','Gallery',[this.props.error?Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'p','Error',this.props.error,0):"",this.props.images.map(function(image,i){return Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["b" /* createComponentVNode */])(2,__WEBPACK_IMPORTED_MODULE_1__GalleryItem__["a" /* default */],{'index':i,'imageData':image,'loggedIn':_this2.props.loggedIn,'setModal':_this2.props.setModal,'swapImages':_this2.props.swapImages});})],0)],4,{'id':'gallery'});}}]);return Gallery;}(__WEBPACK_IMPORTED_MODULE_0_inferno__["a" /* Component */]);/* harmony default export */ __webpack_exports__["a"] = (Gallery);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inferno__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GalleryItem=function(_Component){_inherits(GalleryItem,_Component);function GalleryItem(){_classCallCheck(this,GalleryItem);var _this=_possibleConstructorReturn(this,(GalleryItem.__proto__||Object.getPrototypeOf(GalleryItem)).call(this));_this.state={loaded:false};return _this;}_createClass(GalleryItem,[{key:"handleImageLoaded",value:function handleImageLoaded(){this.setState({loaded:true});}},{key:"handleDragStart",value:function handleDragStart(e){e.dataTransfer.setData("start",this.props.index);}},{key:"handleDragOver",value:function handleDragOver(e){e.preventDefault();}},{key:"handleDrop",value:function handleDrop(e){e.preventDefault();if(!this.props.loggedIn)return;var start=e.dataTransfer.getData("start");var finish=this.props.index.toString();if(start===finish)return;this.props.swapImages(start,finish);}},{key:"render",value:function render(){var _this2=this;var id=this.props.imageData._id;var _props=this.props,loggedIn=_props.loggedIn,index=_props.index;return Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Gallery__item",[loggedIn?Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Gallery__item--admin",[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"button","Gallery__item--admin--edit",Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])("Edit"),2,{"onClick":function onClick(){return _this2.props.setModal("editPhoto",index);}}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"button","Gallery__item--admin--delete",Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])("\xD7 Delete"),2,{"onClick":function onClick(){return _this2.props.setModal("deletePhoto",id);}})],4):"",Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Gallery__item--image--wrapper",id?Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"img","Gallery__item--image "+(this.state.loaded?"loaded":""),null,1,{"src":"/images/gallery/"+id+"/thumbnail.jpg","onLoad":function onLoad(){return _this2.handleImageLoaded();},"alt":""}):'',0,{"onClick":function onClick(){return _this2.props.setModal("lightbox",index);}})],0,{"draggable":true,"ondragstart":this.handleDragStart.bind(this),"ondragover":this.handleDragOver.bind(this),"ondrop":this.handleDrop.bind(this)});}}]);return GalleryItem;}(__WEBPACK_IMPORTED_MODULE_0_inferno__["a" /* Component */]);/* harmony default export */ __webpack_exports__["a"] = (GalleryItem);

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inferno__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Profile=function(_Component){_inherits(Profile,_Component);function Profile(){_classCallCheck(this,Profile);return _possibleConstructorReturn(this,(Profile.__proto__||Object.getPrototypeOf(Profile)).apply(this,arguments));}_createClass(Profile,[{key:"render",value:function render(){return Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Profile container",[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"section","About",[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"img","About__image",null,1,{"src":"/images/about/james-booth-profile-photo.jpg","alt":"James Booth"}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","About__text",[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"h2",null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])("Hi, I'm James"),2),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"p",null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])("I was born somewhere, and then grew up. Along the way I served 27 years in the military where I learned very important stuff like how to poop in a plastic bag and clean a rifle. Then I left and now live in Stoke on Trent where I do other stuff such as photography. I hope to continue doing stuff for quite some time."),2)],4)],4,{"id":"about"}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"section","Gear",Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Gear__text",[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"h2",null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])("Gear"),2),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"ul",null,[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"li",null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])("Canon 5D Mark IV"),2),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"li",null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])("Sigma 85mm f/1.4 Art"),2),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"li",null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])("Canon 70-200mm f/2.8 mkII"),2),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"li",null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])("Canon 24-70mm f/2.8 mkII"),2)],4)],4),2,{"id":"gear"})],4);}}]);return Profile;}(__WEBPACK_IMPORTED_MODULE_0_inferno__["a" /* Component */]);/* harmony default export */ __webpack_exports__["a"] = (Profile);

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inferno__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Footer=function(_Component){_inherits(Footer,_Component);function Footer(){_classCallCheck(this,Footer);return _possibleConstructorReturn(this,(Footer.__proto__||Object.getPrototypeOf(Footer)).apply(this,arguments));}_createClass(Footer,[{key:"render",value:function render(){var _this2=this;return Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Footer",Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","container",[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"p",null,[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])("Website by "),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"a",null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])("AMP Studio"),2,{"href":"https://amp.studio","target":"_blank"})],4),this.props.loggedIn?Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Footer--login",Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])("Log out"),2,{"onClick":function onClick(){return _this2.props.logOut();}}):Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Footer--login",Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])("Log in"),2,{"onClick":function onClick(){return _this2.props.setModal('login');}})],0),2);}}]);return Footer;}(__WEBPACK_IMPORTED_MODULE_0_inferno__["a" /* Component */]);/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inferno__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AdminBar=function(_Component){_inherits(AdminBar,_Component);function AdminBar(){_classCallCheck(this,AdminBar);return _possibleConstructorReturn(this,(AdminBar.__proto__||Object.getPrototypeOf(AdminBar)).apply(this,arguments));}_createClass(AdminBar,[{key:"render",value:function render(){var _this2=this;if(!this.props.username)return;return Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","AdminBar",Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","container",[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"p",null,"Logged in as "+this.props.username,0),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","AdminBar__buttons",Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"button",null,[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"img",null,null,1,{"src":"/images/icons/picture.svg","alt":"Add a new entry"}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])("Add photo")],4,{"onClick":function onClick(){return _this2.props.setModal('addPhoto');}}),2)],4),2);}}]);return AdminBar;}(__WEBPACK_IMPORTED_MODULE_0_inferno__["a" /* Component */]);/* harmony default export */ __webpack_exports__["a"] = (AdminBar);

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inferno__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalLogin__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModalLightbox__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalAddPhoto__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalEditPhoto__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalDeletePhoto__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Modals=function(_Component){_inherits(Modals,_Component);function Modals(){_classCallCheck(this,Modals);return _possibleConstructorReturn(this,(Modals.__proto__||Object.getPrototypeOf(Modals)).apply(this,arguments));}_createClass(Modals,[{key:'render',value:function render(){var _props=this.props,modals=_props.modals,setModal=_props.setModal,url=_props.url,updateGallery=_props.updateGallery,image=_props.image;return Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','Modals',[modals.lightbox!==false?Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["b" /* createComponentVNode */])(2,__WEBPACK_IMPORTED_MODULE_2__ModalLightbox__["a" /* default */],{'setModal':setModal,'image':image,'index':modals.lightbox}):"",modals.login?Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["b" /* createComponentVNode */])(2,__WEBPACK_IMPORTED_MODULE_1__ModalLogin__["a" /* default */],{'setModal':setModal,'url':url}):"",modals.addPhoto?Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["b" /* createComponentVNode */])(2,__WEBPACK_IMPORTED_MODULE_3__ModalAddPhoto__["a" /* default */],{'categories':this.props.categories,'setModal':setModal,'updateGallery':updateGallery,'url':url}):"",modals.editPhoto!==false?Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["b" /* createComponentVNode */])(2,__WEBPACK_IMPORTED_MODULE_4__ModalEditPhoto__["a" /* default */],{'categories':this.props.categories,'setModal':setModal,'updateGallery':updateGallery,'image':image,'url':url}):"",modals.deletePhoto?Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["b" /* createComponentVNode */])(2,__WEBPACK_IMPORTED_MODULE_5__ModalDeletePhoto__["a" /* default */],{'setModal':setModal,'updateGallery':updateGallery,'url':url,'id':modals.deletePhoto}):""],0);}}]);return Modals;}(__WEBPACK_IMPORTED_MODULE_0_inferno__["a" /* Component */]);/* harmony default export */ __webpack_exports__["a"] = (Modals);

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inferno__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalLogin=function(_Component){_inherits(ModalLogin,_Component);function ModalLogin(){_classCallCheck(this,ModalLogin);var _this=_possibleConstructorReturn(this,(ModalLogin.__proto__||Object.getPrototypeOf(ModalLogin)).call(this));_this.state={name:'',password:'',loginFailed:false};return _this;}_createClass(ModalLogin,[{key:'submitLoginForm',value:function submitLoginForm(e){var _this2=this;e.preventDefault();var loginData={name:this.state.name,password:this.state.password};fetch(this.props.url+"login",{body:JSON.stringify(loginData),method:'POST',credentials:'include',headers:{'Content-Type':'application/json'}}).then(function(res){if(res.status===200){window.scrollTo(0,0);window.location.reload();}else{_this2.setState({loginFailed:true});}});}},{key:'handleNameChange',value:function handleNameChange(e){this.setState({name:e.target.value,loginFailed:false});}},{key:'handlePasswordChange',value:function handlePasswordChange(e){this.setState({password:e.target.value,loginFailed:false});}},{key:'render',value:function render(){var _this3=this;return Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','Modal',Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'form','Modal__window',[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','Modal__close',Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('\xD7'),2,{'onClick':function onClick(){return _this3.props.setModal("login",false);}}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'label',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('name'),2,{'for':'name'}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(64,'input',null,null,1,{'name':'name','type':'name','value':this.state.name,'onInput':function onInput(e){return _this3.handleNameChange(e);},'required':true}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'label',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Password'),2,{'for':'password'}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(64,'input',null,null,1,{'name':'password','type':'password','value':this.state.password,'onInput':function onInput(e){return _this3.handlePasswordChange(e);},'required':true}),this.state.loginFailed?Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'p','Error',Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Login failed, please try again.'),2):null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'button',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Log In'),2,{'type':'submit'})],0,{'onSubmit':function onSubmit(e){_this3.submitLoginForm(e);}}),2);}}]);return ModalLogin;}(__WEBPACK_IMPORTED_MODULE_0_inferno__["a" /* Component */]);/* harmony default export */ __webpack_exports__["a"] = (ModalLogin);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inferno__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalLightbox=function(_Component){_inherits(ModalLightbox,_Component);function ModalLightbox(){_classCallCheck(this,ModalLightbox);var _this=_possibleConstructorReturn(this,(ModalLightbox.__proto__||Object.getPrototypeOf(ModalLightbox)).call(this));_this.state={loaded:false};return _this;}_createClass(ModalLightbox,[{key:"handleImageLoaded",value:function handleImageLoaded(){var loaded=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;this.setState({loaded:loaded});}},{key:"render",value:function render(){var _this2=this;var _props=this.props,image=_props.image,index=_props.index;var hasMeta=false;Object.keys(image.meta).forEach(function(key){if(key==="category")return;if(image.meta[key]!=="")hasMeta=true;});return Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Modal",[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Lightbox__pagination Lightbox__pagination--prev","<",0,{"onClick":function onClick(e){_this2.handleImageLoaded(false);_this2.props.setModal("lightbox",index-1);}}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Lightbox__pagination Lightbox__pagination--next",">",0,{"onClick":function onClick(){_this2.handleImageLoaded(false);_this2.props.setModal("lightbox",index+1);}}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Modal__window",[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Modal__close",Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])("\xD7 "),2,{"onClick":function onClick(){return _this2.props.setModal("lightbox",false);}}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Lightbox "+(hasMeta?"":"Lightbox__no-meta"),[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Lightbox__photo "+(this.state.loaded?"":"fade"),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"img",null,null,1,{"src":"/images/gallery/"+image._id+"/large.jpg","onLoad":function onLoad(){return _this2.handleImageLoaded();},"alt":""}),2),hasMeta?Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Lightbox__meta",[image.meta.description?Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div",null,[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"label",null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])("Description"),2),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Lightbox__meta--content",image.meta.description,0)],4):'',image.meta.camera?Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div",null,[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"label",null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])("Camera"),2),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Lightbox__meta--content",image.meta.camera,0)],4):'',image.meta.lens?Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div",null,[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"label",null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])("Lens"),2),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Lightbox__meta--content",image.meta.lens,0)],4):'',Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Lightbox__meta--inputs",[image.meta.iso?Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Lightbox__meta--inputs--input",[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"label",null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])("ISO"),2),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Lightbox__meta--content",image.meta.iso,0)],4):'',image.meta.aperture?Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Lightbox__meta--inputs--input",[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"label",null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])("Aperture"),2),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Lightbox__meta--content",[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])("f/"),image.meta.aperture],0)],4):'',image.meta.shutterSpeed?Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Lightbox__meta--inputs--input",[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"label",null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])("Shutter Speed"),2),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Lightbox__meta--content",image.meta.shutterSpeed,0)],4):'',image.meta.focalLength?Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Lightbox__meta--inputs--input",[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"label",null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])("Focal Length"),2),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,"div","Lightbox__meta--content",image.meta.focalLength,0)],4):''],0)],0):""],0)],4)],4,{"onClick":function onClick(e){if(e.target.attributes.class&&e.target.attributes.class.value==='Modal')_this2.props.setModal("lightbox",false);}});}}]);return ModalLightbox;}(__WEBPACK_IMPORTED_MODULE_0_inferno__["a" /* Component */]);/* harmony default export */ __webpack_exports__["a"] = (ModalLightbox);

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inferno__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalAddPhoto=function(_Component){_inherits(ModalAddPhoto,_Component);function ModalAddPhoto(){_classCallCheck(this,ModalAddPhoto);var _this=_possibleConstructorReturn(this,(ModalAddPhoto.__proto__||Object.getPrototypeOf(ModalAddPhoto)).call(this));_this.state={uploadStatus:null,imageData:null,categories:[],meta:{}};return _this;}_createClass(ModalAddPhoto,[{key:'submitForm',value:function submitForm(e){var _this2=this;e.preventDefault();this.setState({uploadStatus:"uploading"});var meta={description:e.target.description.value,category:this.state.categories,camera:e.target.camera.value,lens:e.target.lens.value,iso:e.target.iso.value,aperture:e.target.aperture.value,shutterSpeed:e.target.shutterSpeed.value,focalLength:e.target.focalLength.value};this.state.categories.forEach(function(category){if(e.target[category].checked)meta.category.push(category);});var data=new FormData();data.append('meta',JSON.stringify(meta));data.append('file',e.target.file.files[0]);fetch(this.props.url+"admin/new",{body:data,method:'POST',credentials:'include'}).then(function(res){setTimeout(function(){_this2.props.updateGallery();_this2.props.setModal('addPhoto',false);},1000);}).catch(function(){_this2.setState({uploadStatus:"failed"});});}},{key:'handleFileInput',value:function handleFileInput(e){var _this3=this;e.preventDefault();var file=e.target.files[0];if(!file)return this.setState({imageData:false});var reader=new FileReader();reader.onloadend=function(e){return _this3.setState({imageData:e.target.result});};reader.readAsDataURL(file);}},{key:'handleCategoryInput',value:function handleCategoryInput(e){var categories=this.state.categories;var key=e.target.dataset.key;var newValue=e.target.value;categories[key]=newValue;this.setState({categories:categories});}},{key:'addCategory',value:function addCategory(e){e.preventDefault();var categories=this.state.categories;if(categories[categories.length-1]==="")return;categories.push("");this.setState({categories:categories});}},{key:'deleteCategory',value:function deleteCategory(e){e.preventDefault();var categories=this.state.categories;var index=e.target.dataset.key;categories.splice(index,1);this.setState({categories:categories});}},{key:'render',value:function render(){var _this4=this;return Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','Modal',[this.state.uploadStatus==="uploading"?Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','Modal',Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'p',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Uploading...'),2),2):"",Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'form','Modal__window',[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','Modal__close',Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('\xD7 '),2,{'onClick':function onClick(){return _this4.props.setModal("addPhoto",false);}}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','AddPhoto',[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','AddPhoto__photo '+(this.state.imageData?"":"fade"),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'img',null,null,1,{'src':this.state.imageData||"",'alt':''}),2),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','AddPhoto__meta',[this.state.imageData?Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'label',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Image File'),2,{'for':'file'}):'',Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(64,'input',this.state.imageData?"":"AddPhoto__meta--file-drop",null,1,{'type':'file','id':'file','name':'file','accept':'image/*','onChange':this.handleFileInput.bind(this)}),!this.state.imageData?Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'label',null,[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'img',null,null,1,{'src':'/images/icons/upload.svg','alt':'Upload'}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Upload Image')],4,{'for':'file'}):'',this.state.imageData?Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div',null,[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'label',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Description'),2,{'for':'description'}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(128,'textarea',null,null,1,{'name':'description','rows':'3'}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'label',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Categories'),2),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','categories',this.state.categories.map(function(category,i){return Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div',null,[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(64,'input',null,null,1,{'name':category,'data-key':i,'value':category,'onInput':function onInput(e){return _this4.handleCategoryInput(e);}}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'button',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('\xD7'),2,{'data-key':i,'onClick':function onClick(e){return _this4.deleteCategory(e);}})],4);}),0),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'button',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Add category'),2,{'onClick':function onClick(e){return _this4.addCategory(e);}}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'label',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Camera'),2,{'for':'camera'}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(64,'input',null,null,1,{'name':'camera','type':'text','placeholder':'Canon 5D mkIV'}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'label',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Lens'),2,{'for':'lens'}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(64,'input',null,null,1,{'name':'lens','type':'text','placeholder':'Canon 70-200 f/2.8'}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','AddPhoto__meta--inputs',[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','AddPhoto__meta--inputs--input',[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'label',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('ISO'),2,{'for':'iso'}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(64,'input',null,null,1,{'name':'iso','type':'number','placeholder':'800'})],4),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','AddPhoto__meta--inputs--input',[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'label',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Aperture'),2,{'for':'aperture'}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(64,'input',null,null,1,{'name':'aperture','type':'number','step':'0.1','placeholder':'2.8'})],4),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','AddPhoto__meta--inputs--input',[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'label',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Shutter Speed'),2,{'for':'shutterSpeed'}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(64,'input',null,null,1,{'name':'shutterSpeed','type':'text','placeholder':'1/500'})],4),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','AddPhoto__meta--inputs--input',[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'label',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Focal Length'),2,{'for':'focalLength'}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(64,'input',null,null,1,{'name':'focalLength','type':'number','placeholder':'50'})],4)],4),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'button',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Add Photo'),2,{'type':'submit'})],4):""],0)],4)],4,{'onSubmit':function onSubmit(e){return _this4.submitForm(e);}})],0);}}]);return ModalAddPhoto;}(__WEBPACK_IMPORTED_MODULE_0_inferno__["a" /* Component */]);/* harmony default export */ __webpack_exports__["a"] = (ModalAddPhoto);

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inferno__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalEditPhoto=function(_Component){_inherits(ModalEditPhoto,_Component);function ModalEditPhoto(){_classCallCheck(this,ModalEditPhoto);var _this=_possibleConstructorReturn(this,(ModalEditPhoto.__proto__||Object.getPrototypeOf(ModalEditPhoto)).call(this));_this.state={meta:{},categories:[]};return _this;}_createClass(ModalEditPhoto,[{key:'componentWillMount',value:function componentWillMount(){this.setState({meta:this.props.image.meta,categories:this.props.image.meta.category});}},{key:'submitForm',value:function submitForm(e){var _this2=this;e.preventDefault();var cleanCategories=this.state.categories.filter(function(string){return string.match(/[a-zA-Z]/g);});var meta={description:e.target.description.value,category:cleanCategories,camera:e.target.camera.value,lens:e.target.lens.value,iso:e.target.iso.value,aperture:e.target.aperture.value,shutterSpeed:e.target.shutterSpeed.value,focalLength:e.target.focalLength.value};fetch(this.props.url+'admin/edit/'+this.props.image._id,{body:JSON.stringify(meta),method:'POST',credentials:'include',headers:{'Accept':'application/json','Content-Type':'application/json'}}).then(function(res){setTimeout(function(){_this2.props.updateGallery();_this2.props.setModal('editPhoto',false);},500);}).catch(function(){_this2.setState({editStatus:"failed"});});}},{key:'updateMeta',value:function updateMeta(key,value){var meta=Object.assign({},this.state.meta);meta[key]=value;console.log(meta);this.setState({meta:meta});}},{key:'handleCategoryInput',value:function handleCategoryInput(e){var categories=this.state.categories;var key=e.target.dataset.key;var newValue=e.target.value;categories[key]=newValue;this.setState({categories:categories});}},{key:'addCategory',value:function addCategory(e){e.preventDefault();var categories=this.state.categories;if(categories[categories.length-1]==="")return;categories.push("");this.setState({categories:categories});}},{key:'deleteCategory',value:function deleteCategory(e){e.preventDefault();var categories=this.state.categories;var index=e.target.dataset.key;categories.splice(index,1);this.setState({categories:categories});}},{key:'render',value:function render(){var _this3=this;var image=this.props.image;return Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','Modal',Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'form','Modal__window',[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','Modal__close',Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('\xD7 '),2,{'onClick':function onClick(){return _this3.props.setModal("editPhoto",false);}}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','AddPhoto',[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','AddPhoto__photo',Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'img',null,null,1,{'src':'/images/gallery/'+image._id+'/large.jpg','alt':''}),2),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','AddPhoto__meta',Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div',null,[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'label',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Description'),2,{'for':'description'}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(128,'textarea',null,this.state.meta.description,0,{'name':'description','rows':'3'}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'label',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Categories'),2),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','categories',this.state.categories.map(function(category,i){return Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div',null,[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(64,'input',null,null,1,{'name':category,'data-key':i,'value':category,'onInput':function onInput(e){return _this3.handleCategoryInput(e);}}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'button',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('\xD7'),2,{'data-key':i,'onClick':function onClick(e){return _this3.deleteCategory(e);}})],4);}),0),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'button',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Add category'),2,{'onClick':function onClick(e){return _this3.addCategory(e);}}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'label',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Camera'),2,{'for':'camera'}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(64,'input',null,null,1,{'name':'camera','type':'text','defaultValue':this.state.meta.camera}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'label',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Lens'),2,{'for':'lens'}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(64,'input',null,null,1,{'name':'lens','type':'text','defaultValue':this.state.meta.lens}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','AddPhoto__meta--inputs',[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','AddPhoto__meta--inputs--input',[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'label',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('ISO'),2,{'for':'iso'}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(64,'input',null,null,1,{'name':'iso','type':'number','defaultValue':this.state.meta.iso})],4),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','AddPhoto__meta--inputs--input',[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'label',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Aperture'),2,{'for':'aperture'}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(64,'input',null,null,1,{'name':'aperture','type':'number','step':'0.1','defaultValue':this.state.meta.aperture})],4),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','AddPhoto__meta--inputs--input',[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'label',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Shutter Speed'),2,{'for':'shutterSpeed'}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(64,'input',null,null,1,{'name':'shutterSpeed','type':'text','defaultValue':this.state.meta.shutterSpeed})],4),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','AddPhoto__meta--inputs--input',[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'label',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Focal Length'),2,{'for':'focalLength'}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(64,'input',null,null,1,{'name':'focalLength','type':'number','defaultValue':this.state.meta.focalLength})],4)],4),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'button',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Save Changes'),2,{'type':'submit'})],4),2)],4)],4,{'onSubmit':function onSubmit(e){return _this3.submitForm(e);}}),2);}}]);return ModalEditPhoto;}(__WEBPACK_IMPORTED_MODULE_0_inferno__["a" /* Component */]);/* harmony default export */ __webpack_exports__["a"] = (ModalEditPhoto);

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inferno__ = __webpack_require__(0);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalDeletePhoto=function(_Component){_inherits(ModalDeletePhoto,_Component);function ModalDeletePhoto(){_classCallCheck(this,ModalDeletePhoto);var _this=_possibleConstructorReturn(this,(ModalDeletePhoto.__proto__||Object.getPrototypeOf(ModalDeletePhoto)).call(this));_this.state={error:false};return _this;}_createClass(ModalDeletePhoto,[{key:'deletePhoto',value:function deletePhoto(id){var _this2=this;fetch(this.props.url+('admin/delete/'+id),{method:'POST',credentials:'include'}).then(function(){_this2.props.updateGallery();_this2.props.setModal('deletePhoto',false);}).catch(function(err){console.log(err);_this2.setState({error:true});});}},{key:'render',value:function render(){var _this3=this;var id=this.props.id;return Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','Modal',Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div','Modal__window DeletePhoto',[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'p',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Delete this photo?'),2),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'img','DeletePhoto__image',null,1,{'src':'/images/gallery/'+this.props.id+'/thumbnail.jpg','alt':''}),this.state.error?Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'p','Error',Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Error deleting photo'),2):'',Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'div',null,[Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'button',null,Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Cancel'),2,{'onClick':function onClick(){return _this3.props.setModal('deletePhoto',false);}}),Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["d" /* createVNode */])(1,'button','warning',Object(__WEBPACK_IMPORTED_MODULE_0_inferno__["c" /* createTextVNode */])('Delete'),2,{'onClick':function onClick(){return _this3.deletePhoto(id);}})],4)],0),2);}}]);return ModalDeletePhoto;}(__WEBPACK_IMPORTED_MODULE_0_inferno__["a" /* Component */]);/* harmony default export */ __webpack_exports__["a"] = (ModalDeletePhoto);

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.7e99bc70.js